// /**
//  * LGND CART DRAWER REWARDS
//  *
//  * Shared cart controller for:
//  * - cumulative spend-tier progress;
//  * - Buy X Get Y product gifts;
//  * - spend-tier bonus-entry codes; and
//  * - existing time-based bonus-entry campaigns.
//  *
//  * Safety rules:
//  * - qualifying merchandise uses original line prices before discounts;
//  * - reward gifts, Route protection, and nested bundle children never qualify;
//  * - a product gift remains in the cart only when Shopify confirms that the
//  *   configured discount makes that exact tagged line free;
//  * - existing customer-entered discount codes are preserved and take priority;
//  * - reward writes are serialized and stop when a newer customer change arrives.
//  */
// (() => {
//   "use strict";

//   if (window.LGNDCartDrawerRewards) return;

//   const REWARDS_CONFIG_SELECTOR = "[data-lgnd-cart-rewards-config]";
//   const BONUS_CONFIG_SELECTOR = "[data-lgnd-bonus-cart-gift-config]";
//   const REWARDS_ROOT_SELECTOR = "[data-lgnd-cart-rewards]";
//   const CART_MUTATION_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/;
//   const CONTROLLER_SOURCE = "cart-drawer-rewards";
//   const STORED_CODES_KEY = "lgnd:cart-drawer-rewards:auto-codes";
//   const LEGACY_STORED_CODES_KEY = "lgnd:auto-bonus-cart-gift-code";
//   const FAILURE_COOLDOWN_MS = 60 * 1000;
//   const REJECTION_VERIFICATION_DELAY_MS = 250;
//   const MAX_DISCOUNT_CODES = 5;

//   // Route Code Edited 9/11/2026
//   const ROUTE_HANDLE = "routeins";
//   // End Route Code

//   const routeRoot =
//     window.Shopify && window.Shopify.routes && window.Shopify.routes.root
//       ? window.Shopify.routes.root
//       : "/";

//   const cartBaseRoute = routeRoot.replace(/\/?$/, "/") + "cart";
//   const originalFetch = window.fetch.bind(window);

//   const state = {
//     syncing: false,
//     syncQueued: false,
//     syncTimer: 0,
//     boundaryTimer: 0,
//     failureTimer: 0,
//     latestCart: null,
//     giftFailures: new Map(),
//     codeFailures: new Map(),
//     skippedCodes: new Set(),
//     report: null
//   };

//   // LGND CART DRAWER REWARDS — NORMALIZATION HELPERS START
//   function normalizeCode(value) {
//     return String(value || "").trim().toLowerCase();
//   }

//   function normalizeId(value) {
//     const normalized = String(value || "").trim();

//     return normalized && normalized !== "0" && normalized !== "null"
//       ? normalized
//       : "";
//   }

//   function normalizeCampaignType(value) {
//     const normalized = String(value || "")
//       .trim()
//       .toLowerCase()
//       .replace(/[_-]+/g, " ")
//       .replace(/\s+/g, " ");

//     if (!normalized || normalized === "store wide") return "store_wide";
//     if (normalized === "product specific") return "product_specific";

//     return "";
//   }

//   function uniqueValues(values, normalizer) {
//     const results = [];
//     const keys = new Set();

//     values.forEach((value) => {
//       const normalized = normalizer(value);
//       if (!normalized || keys.has(normalized)) return;

//       keys.add(normalized);
//       results.push(String(value).trim());
//     });

//     return results;
//   }

//   function parseShopifyDate(value) {
//     if (typeof value === "number" && Number.isFinite(value)) {
//       return value > 100000000000 ? value : value * 1000;
//     }

//     let dateValue = String(value || "").trim();
//     if (!dateValue) return null;

//     const hasTimeZone = /(?:z|[+-]\d{2}:?\d{2})$/i.test(dateValue);
//     const isIsoDateTime = /^\d{4}-\d{2}-\d{2}t\d{2}:\d{2}/i.test(dateValue);

//     if (isIsoDateTime && !hasTimeZone) dateValue += "Z";

//     const timestamp = Date.parse(dateValue);
//     return Number.isFinite(timestamp) ? timestamp : null;
//   }

//   function getCurrencyRate() {
//     const currency =
//       window.Shopify && window.Shopify.currency
//         ? window.Shopify.currency
//         : {};

//     const rate = Number(currency.rate);
//     return Number.isFinite(rate) && rate > 0 ? rate : 1;
//   }

//   function convertThreshold(baseCents) {
//     return Math.max(
//       0,
//       Math.round(Number(baseCents || 0) * getCurrencyRate())
//     );
//   }

//   function valuesMatch(leftValues, rightValues, normalizer) {
//     const left = uniqueValues(leftValues, normalizer)
//       .map(normalizer)
//       .sort();

//     const right = uniqueValues(rightValues, normalizer)
//       .map(normalizer)
//       .sort();

//     return left.join("|") === right.join("|");
//   }

//   function wait(milliseconds) {
//     return new Promise((resolve) => {
//       window.setTimeout(resolve, milliseconds);
//     });
//   }
//   // LGND CART DRAWER REWARDS — NORMALIZATION HELPERS END

//   // LGND CART DRAWER REWARDS — CONFIGURATION READER START
//   function normalizeCampaign(rawCampaign) {
//     const raw =
//       rawCampaign && typeof rawCampaign === "object"
//         ? rawCampaign
//         : {};

//     const startsAt = parseShopifyDate(raw.startsAt);
//     const endsAt = parseShopifyDate(raw.endsAt);
//     const campaignType = normalizeCampaignType(raw.campaignType);

//     const qualifyingProductIds = uniqueValues(
//       Array.isArray(raw.qualifyingProductIds)
//         ? raw.qualifyingProductIds
//         : [],
//       normalizeId
//     ).map(normalizeId);

//     const excludedProductIds = uniqueValues(
//       Array.isArray(raw.excludedProductIds)
//         ? raw.excludedProductIds
//         : [],
//       normalizeId
//     ).map(normalizeId);

//     return {
//       id: normalizeId(raw.id || raw.campaignId),
//       code: String(raw.code || "").trim(),
//       autoApply: raw.autoApply === true,
//       startsAt,
//       endsAt,
//       campaignType,
//       qualifyingProductIds,
//       excludedProductIds,
//       entries: Math.max(0, Number(raw.entries || 0)),
//       title: String(raw.title || "Bonus Entries Gift").trim(),
//       image: raw.image || null
//     };
//   }

//   function campaignTargetingIssue(campaign) {
//     if (!campaign || !campaign.code) return "missing discount code";
//     if (!campaign.campaignType) return "invalid campaign type";

//     if (
//       campaign.campaignType === "product_specific" &&
//       !campaign.qualifyingProductIds.length
//     ) {
//       return "product-specific campaign has no qualifying products";
//     }

//     return "";
//   }

//   function campaignConfigurationIssue(campaign) {
//     const targetingIssue = campaignTargetingIssue(campaign);
//     if (targetingIssue) return targetingIssue;

//     if (campaign.startsAt === null) return "missing or invalid start date";
//     if (campaign.endsAt === null) return "missing or invalid end date";

//     if (campaign.endsAt < campaign.startsAt) {
//       return "end date is before start date";
//     }

//     return "";
//   }

//   // Cart Reward blocks control their own activation and threshold.
//   // Standalone auto-apply and scheduling fields do not control them.
//   function tierBonusConfigurationIssue(campaign) {
//     return campaignTargetingIssue(campaign);
//   }

//   function readRewardsConfiguration() {
//     let rawConfiguration = null;
//     const errors = [];

//     document.querySelectorAll(REWARDS_CONFIG_SELECTOR).forEach((element) => {
//       try {
//         const parsed = JSON.parse(element.textContent || "{}");

//         if (parsed && typeof parsed === "object") {
//           rawConfiguration = parsed;
//         }
//       } catch (error) {
//         errors.push(
//           error && error.message
//             ? error.message
//             : "Invalid rewards JSON"
//         );
//       }
//     });

//     const raw = rawConfiguration || {};
//     const tiers = [];
//     const tierIds = new Set();

//     (Array.isArray(raw.tiers) ? raw.tiers : []).forEach((rawTier, index) => {
//       const tierId = String(
//         (rawTier && rawTier.id) || "tier-" + index
//       ).trim();

//       const type = String(
//         (rawTier && rawTier.type) || ""
//       ).trim();

//       const thresholdBaseCents = Math.max(
//         0,
//         Math.round(
//           Number((rawTier && rawTier.thresholdBaseCents) || 0)
//         )
//       );

//       if (
//         !tierId ||
//         tierIds.has(tierId) ||
//         !["free_shipping", "free_gift", "bonus_entries"].includes(type) ||
//         thresholdBaseCents <= 0
//       ) {
//         return;
//       }

//       tierIds.add(tierId);

//       const rawGift =
//         rawTier.gift && typeof rawTier.gift === "object"
//           ? rawTier.gift
//           : {};

//       const bonus = normalizeCampaign(rawTier.bonus);

//       tiers.push({
//         id: tierId,
//         order: index,
//         type,
//         title: String(rawTier.title || "Reward").trim() || "Reward",
//         thresholdBaseCents,
//         thresholdCents: convertThreshold(thresholdBaseCents),
//         memberOverride: rawTier.memberOverride === true,
//         icon: rawTier.icon || null,
//         gift: {
//           productId: normalizeId(rawGift.productId),
//           variantId: normalizeId(rawGift.variantId),
//           available: rawGift.available === true,
//           singleVariant: rawGift.singleVariant === true,
//           productTitle: String(rawGift.productTitle || "").trim(),
//           expectedDiscountTitle: String(
//             rawGift.expectedDiscountTitle || ""
//           ).trim()
//         },
//         bonus
//       });
//     });

//     tiers.sort((left, right) => {
//       return (
//         left.thresholdBaseCents - right.thresholdBaseCents ||
//         left.order - right.order
//       );
//     });

//     const configuredOffset = Number(raw.firstMilestoneOffset);

//     return {
//       isPresent: Boolean(rawConfiguration),
//       enabled: raw.enabled === true,
//       member: raw.member === true,
//       memberTag: String(raw.memberTag || "").trim(),
//       storeCurrency: String(raw.storeCurrency || "USD").trim(),
//       presentmentCurrency: String(
//         raw.presentmentCurrency ||
//           (
//             window.Shopify &&
//             window.Shopify.currency &&
//             window.Shopify.currency.active
//               ? window.Shopify.currency.active
//               : "USD"
//           )
//       ).trim(),
//       firstMilestoneOffset: Number.isFinite(configuredOffset)
//         ? Math.max(0, Math.min(configuredOffset, 25))
//         : 10,
//       messages: {
//         next: String(
//           (raw.messages && raw.messages.next) ||
//             "You're [amount] away from [reward]!"
//         ),
//         complete: String(
//           (raw.messages && raw.messages.complete) ||
//             "You've unlocked every reward!"
//         ),
//         memberShipping: String(
//           (raw.messages && raw.messages.memberShipping) ||
//             "Member Free-Shipping unlocked!"
//         )
//       },
//       tiers,
//       errors
//     };
//   }

//   function readTimedBonusConfiguration() {
//     const campaigns = [];
//     const campaignKeys = new Set();
//     const appliedDiscountCodes = [];
//     const appliedCodeKeys = new Set();
//     const errors = [];
//     const elements = document.querySelectorAll(BONUS_CONFIG_SELECTOR);

//     elements.forEach((element) => {
//       try {
//         const raw = JSON.parse(element.textContent || "{}");

//         (Array.isArray(raw.campaigns) ? raw.campaigns : []).forEach(
//           (rawCampaign) => {
//             const campaign = normalizeCampaign(rawCampaign);

//             const campaignKey = [
//               normalizeCode(campaign.code),
//               campaign.startsAt,
//               campaign.endsAt,
//               campaign.campaignType,
//               campaign.qualifyingProductIds.slice().sort().join(","),
//               campaign.excludedProductIds.slice().sort().join(",")
//             ].join("|");

//             if (campaignKeys.has(campaignKey)) return;

//             campaignKeys.add(campaignKey);
//             campaigns.push(campaign);
//           }
//         );

//         (
//           Array.isArray(raw.appliedDiscountCodes)
//             ? raw.appliedDiscountCodes
//             : []
//         ).forEach((code) => {
//           const key = normalizeCode(code);
//           if (!key || appliedCodeKeys.has(key)) return;

//           appliedCodeKeys.add(key);
//           appliedDiscountCodes.push(String(code).trim());
//         });
//       } catch (error) {
//         errors.push(
//           error && error.message
//             ? error.message
//             : "Invalid bonus JSON"
//         );
//       }
//     });

//     return {
//       isPresent: elements.length > 0,
//       campaigns,
//       appliedDiscountCodes,
//       errors
//     };
//   }

//   // function giftConfigurationIssue(tier) {
//   //   if (!tier || tier.type !== "free_gift") return "";

//   //   if (!tier.gift.productId || !tier.gift.variantId) {
//   //     return "no gift product selected";
//   //   }

//   //   if (!tier.gift.singleVariant) {
//   //     return "gift product must have one variant";
//   //   }

//   //   if (!tier.gift.available) {
//   //     return "gift product is unavailable";
//   //   }

//   //   if (!tier.gift.expectedDiscountTitle) {
//   //     return "expected Buy X Get Y title is blank";
//   //   }

//   //   return "";
//   // }

//   function giftConfigurationIssue(tier) {
//   if (!tier || tier.type !== "free_gift") return "";

//   if (!tier.gift.productId) {
//     return "no gift product selected";
//   }

//   // Multi-variant products are now supported.
//   // Liquid only supplies a variantId when the configured Variant ID
//   // belongs to the selected product. Single-variant products continue
//   // to resolve their default variant automatically.
//   if (!tier.gift.variantId) {
//     return "no valid gift variant selected";
//   }

//   if (!tier.gift.available) {
//     return "gift variant is unavailable";
//   }

//   if (!tier.gift.expectedDiscountTitle) {
//     return "expected Buy X Get Y title is blank";
//   }

//   return "";
// }
//   // LGND CART DRAWER REWARDS — CONFIGURATION READER END

//   // LGND CART DRAWER REWARDS — CART AND ELIGIBILITY HELPERS START
//   function getProperties(item) {
//     return item &&
//       item.properties &&
//       typeof item.properties === "object"
//       ? item.properties
//       : {};
//   }

//   function propertyIsTrue(item, propertyName) {
//     return (
//       String(getProperties(item)[propertyName] || "")
//         .trim()
//         .toLowerCase() === "true"
//     );
//   }

//   function isTierRewardGift(item) {
//     return propertyIsTrue(item, "_lgnd_reward_gift");
//   }

//   function isLegacyRewardGift(item) {
//     return propertyIsTrue(item, "_free_gift");
//   }

//   function isAnyRewardGift(item) {
//     return isTierRewardGift(item) || isLegacyRewardGift(item);
//   }

//   function isRouteProtection(item) {
//     const title = String(
//       (item && (item.product_title || item.title)) || ""
//     ).toLowerCase();

//     return title.includes("shipping protection by route");
//   }

//   function isTopLevelMerchandise(item) {
//     return Boolean(
//       item &&
//         Number(item.quantity || 0) > 0 &&
//         !item.parent_relationship &&
//         !item.parent_id &&
//         !isAnyRewardGift(item) &&
//         !isRouteProtection(item)
//     );
//   }

//   function getMerchandiseItems(cart) {
//     return cart && Array.isArray(cart.items)
//       ? cart.items.filter(isTopLevelMerchandise)
//       : [];
//   }

//   function getQualifyingSubtotal(cart) {
//     return getMerchandiseItems(cart).reduce((subtotal, item) => {
//       const originalLinePrice = Number(item.original_line_price);

//       const fallbackPrice =
//         Number(item.original_price || item.price || 0) *
//         Number(item.quantity || 0);

//       return (
//         subtotal +
//         (
//           Number.isFinite(originalLinePrice)
//             ? originalLinePrice
//             : fallbackPrice
//         )
//       );
//     }, 0);
//   }

//   function campaignIsActive(campaign, now = Date.now()) {
//     return Boolean(
//       campaign &&
//         campaign.autoApply &&
//         !campaignConfigurationIssue(campaign) &&
//         campaign.startsAt <= now &&
//         now <= campaign.endsAt
//     );
//   }

//   function campaignQualifies(campaign, merchandiseItems) {
//     if (campaign.campaignType === "product_specific") {
//       const qualifyingIds = new Set(campaign.qualifyingProductIds);

//       return merchandiseItems.some((item) => {
//         return qualifyingIds.has(normalizeId(item.product_id));
//       });
//     }

//     if (campaign.campaignType === "store_wide") {
//       const excludedIds = new Set(campaign.excludedProductIds);

//       return merchandiseItems.some((item) => {
//         return !excludedIds.has(normalizeId(item.product_id));
//       });
//     }

//     return false;
//   }

//   function tierSpendIsReached(
//     tier,
//     configuration,
//     cart,
//     qualifyingSubtotal
//   ) {
//     if (tier.type === "free_shipping") {
//       const memberUnlock =
//         configuration.member === true &&
//         tier.memberOverride === true;

//       return (
//         memberUnlock ||
//         Math.max(
//           0,
//           Number(cart && cart.total_price ? cart.total_price : 0)
//         ) >= tier.thresholdCents
//       );
//     }

//     return qualifyingSubtotal >= tier.thresholdCents;
//   }

//   function getVisibleTiers(configuration, cart) {
//     if (!configuration.enabled) return [];

//     const merchandiseItems = getMerchandiseItems(cart);
//     const designMode = Boolean(
//       window.Shopify && window.Shopify.designMode
//     );

//     return configuration.tiers.filter((tier) => {
//       if (tier.type === "free_gift") {
//         return !giftConfigurationIssue(tier) || designMode;
//       }

//       if (tier.type === "bonus_entries") {
//         const valid =
//           !tierBonusConfigurationIssue(tier.bonus) &&
//           campaignQualifies(tier.bonus, merchandiseItems);

//         return valid || designMode;
//       }

//       return true;
//     });
//   }

//   function getCartSignature(cart) {
//     const merchandiseSignature = getMerchandiseItems(cart)
//       .map((item) => {
//         return [
//           item.key || item.variant_id,
//           item.product_id,
//           item.variant_id,
//           item.quantity,
//           item.original_line_price
//         ].join(":");
//       })
//       .sort()
//       .join("|");

//     const codeSignature = getAppliedCodes(cart)
//       .map(normalizeCode)
//       .sort()
//       .join("|");

//     return merchandiseSignature + "::" + codeSignature;
//   }
//   // LGND CART DRAWER REWARDS — CART AND ELIGIBILITY HELPERS END

//   // LGND CART DRAWER REWARDS — CART API START
//   async function requestCartJson(path, options = {}) {
//     // PERFORMANCE: reuse full cart responses and bundle the drawer HTML.
//     // Never continue a reward plan after a newer customer cart mutation.
//     assertCurrentPass();

//     const isWrite =
//       String(options.method || "GET").toUpperCase() !== "GET";

//     const sectionIds = isWrite ? getRewardSectionIds() : [];

//     if (isWrite) {
//       syncControl.revision += 1;
//       syncControl.snapshot = null;
//       syncControl.sections = null;
//       syncControl.displayDirty = true;
//       syncControl.writing = true;

//       if (sectionIds.length) {
//         options = {
//           ...options,
//           body: JSON.stringify({
//             ...JSON.parse(options.body || "{}"),
//             sections: sectionIds,
//             sections_url: window.location.pathname
//           })
//         };
//       }
//     }

//     try {
//       const response = await originalFetch(cartBaseRoute + path, {
//         credentials: "same-origin",
//         cache: "no-store",
//         ...options,
//         headers: {
//           Accept: "application/json",
//           "X-Requested-With": "XMLHttpRequest",
//           ...(options.headers || {})
//         }
//       });

//       const payload = await response.json().catch(() => null);
//       assertCurrentPass();

//       if (!response.ok || !payload) {
//         throw new Error(
//           (payload && (payload.description || payload.message)) ||
//             "Shopify rejected a cart update."
//         );
//       }

//       rememberCart(payload, syncControl.revision);

//       if (isWrite && payload.sections) {
//         syncControl.sections = {
//           values: payload.sections,
//           ids: sectionIds,
//           revision: syncControl.revision
//         };
//       }

//       return payload;
//     } finally {
//       if (isWrite) syncControl.writing = false;
//     }
//   }

//   async function getCart() {
//     const cart = await requestCartJson(".js", {
//       method: "GET"
//     });

//     if (!isCompleteCart(cart)) {
//       throw new Error("Shopify returned an incomplete cart.");
//     }

//     return cart;
//   }

//   async function updateCartLines(updates) {
//     if (!updates || !Object.keys(updates).length) return null;

//     const cart = await requestCartJson("/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json"
//       },
//       body: JSON.stringify({ updates })
//     });

//     return isCompleteCart(cart) ? cart : getCart();
//   }

//   async function addRewardGift(tier) {
//     return requestCartJson("/add.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json"
//       },
//       body: JSON.stringify({
//         items: [
//           {
//             id: Number(tier.gift.variantId),
//             quantity: 1,
//             properties: {
//               _lgnd_reward_gift: "true",
//               _lgnd_reward_id: tier.id,
//               _lgnd_reward_title: tier.title,
//               _lgnd_reward_discount: tier.gift.expectedDiscountTitle,
//               _free_gift: "true"
//             }
//           }
//         ]
//       })
//     });
//   }

//   async function updateDiscountCodes(codes) {
//     const cart = await requestCartJson("/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json"
//       },
//       body: JSON.stringify({
//         discount: codes.join(",")
//       })
//     });

//     return isCompleteCart(cart) ? cart : getCart();
//   }
//   // LGND CART DRAWER REWARDS — CART API END

//   // LGND CART DRAWER REWARDS — FAILURE BACKOFF START
//   function failureIsCoolingDown(failureMap, key, signature) {
//     const failure = failureMap.get(key);

//     return Boolean(
//       failure &&
//         failure.signature === signature &&
//         Number(failure.until) > Date.now()
//     );
//   }

//   function storeFailure(failureMap, key, signature, message) {
//     const existing = failureMap.get(key);

//     const attempts =
//       existing && existing.signature === signature
//         ? Number(existing.attempts || 1) + 1
//         : 1;

//     failureMap.set(key, {
//       signature,
//       attempts,
//       message: String(message || "Reward could not be applied."),
//       until: Date.now() + FAILURE_COOLDOWN_MS
//     });

//     scheduleFailureRetry();
//   }

//   function clearFailure(failureMap, key) {
//     failureMap.delete(key);
//     scheduleFailureRetry();
//   }

//   function scheduleFailureRetry() {
//     window.clearTimeout(state.failureTimer);
//     state.failureTimer = 0;

//     const now = Date.now();

//     const retryTimes = [
//       ...state.giftFailures.values(),
//       ...state.codeFailures.values()
//     ]
//       .filter((failure) => {
//         return (
//           failure &&
//           Number(failure.attempts || 1) === 1 &&
//           Number(failure.until) > now
//         );
//       })
//       .map((failure) => Number(failure.until));

//     if (!retryTimes.length) return;

//     const retryAt = Math.min(...retryTimes);

//     state.failureTimer = window.setTimeout(() => {
//       state.failureTimer = 0;
//       requestFreshSync();
//     }, Math.max(50, retryAt - now + 50));
//   }
//   // LGND CART DRAWER REWARDS — FAILURE BACKOFF END

//   // LGND CART DRAWER REWARDS — FREE PRODUCT RECONCILIATION START
//   function rewardIdFromLine(item) {
//     return String(
//       getProperties(item)._lgnd_reward_id || ""
//     ).trim();
//   }

//   function getGiftAssignments(cart, giftTiers) {
//     const giftLines = Array.isArray(cart.items)
//       ? cart.items.filter(isAnyRewardGift)
//       : [];

//     const usedKeys = new Set();
//     const assignments = new Map();

//     giftTiers.forEach((tier) => {
//       const exactLine = giftLines.find((item) => {
//         const properties = getProperties(item);

//         return (
//           !usedKeys.has(item.key) &&
//           rewardIdFromLine(item) === tier.id &&
//           normalizeId(item.variant_id) === tier.gift.variantId &&
//           String(properties._lgnd_reward_title || "").trim() ===
//             tier.title &&
//           normalizeCode(properties._lgnd_reward_discount) ===
//             normalizeCode(tier.gift.expectedDiscountTitle)
//         );
//       });

//       if (!exactLine) return;

//       usedKeys.add(exactLine.key);
//       assignments.set(tier.id, exactLine);
//     });

//     giftTiers.forEach((tier) => {
//       if (assignments.has(tier.id)) return;

//       const legacyLine = giftLines.find((item) => {
//         return (
//           !usedKeys.has(item.key) &&
//           !rewardIdFromLine(item) &&
//           isLegacyRewardGift(item) &&
//           normalizeId(item.variant_id) === tier.gift.variantId
//         );
//       });

//       if (!legacyLine) return;

//       usedKeys.add(legacyLine.key);
//       assignments.set(tier.id, legacyLine);
//     });

//     return {
//       giftLines,
//       usedKeys,
//       assignments
//     };
//   }

//   function discountTitlesForLine(item) {
//     const titles = [];

//     (
//       Array.isArray(item && item.discounts)
//         ? item.discounts
//         : []
//     ).forEach((discount) => {
//       const title = String(
//         (discount && discount.title) || ""
//       ).trim();

//       if (title) titles.push(title);
//     });

//     const allocations = Array.isArray(
//       item && item.line_level_discount_allocations
//     )
//       ? item.line_level_discount_allocations
//       : Array.isArray(item && item.discount_allocations)
//         ? item.discount_allocations
//         : [];

//     allocations.forEach((allocation) => {
//       const application =
//         allocation && allocation.discount_application
//           ? allocation.discount_application
//           : {};

//       const title = String(
//         application.title || application.code || ""
//       ).trim();

//       if (title) titles.push(title);
//     });

//     return uniqueValues(titles, normalizeCode);
//   }

//   function rewardGiftIsVerified(item, tier) {
//     if (!item || Number(item.quantity || 0) !== 1) return false;
//     if (Number(item.final_line_price) !== 0) return false;

//     const expectedTitle = normalizeCode(
//       tier.gift.expectedDiscountTitle
//     );

//     if (!expectedTitle) return false;

//     return discountTitlesForLine(item).some((title) => {
//       return normalizeCode(title) === expectedTitle;
//     });
//   }

//   function getEligibleGiftTiers(configuration, cart) {
//     if (!configuration.enabled) return [];

//     const qualifyingSubtotal = getQualifyingSubtotal(cart);

//     return configuration.tiers.filter((tier) => {
//       if (tier.type !== "free_gift") return false;

//       const configurationIssue = giftConfigurationIssue(tier);

//       if (configurationIssue) {
//         console.warn(
//           "[LGND Cart Drawer Rewards] " +
//             tier.title +
//             " is inactive: " +
//             configurationIssue +
//             "."
//         );

//         return false;
//       }

//       const qualifies = qualifyingSubtotal >= tier.thresholdCents;

//       if (!qualifies) {
//         clearFailure(state.giftFailures, tier.id);
//       }

//       return qualifies;
//     });
//   }

//   async function reconcileGiftLines(cart, configuration) {
//     let workingCart = cart;
//     let changed = false;

//     if (!configuration.enabled) {
//       const updates = {};

//       (
//         Array.isArray(workingCart.items)
//           ? workingCart.items
//           : []
//       ).forEach((item) => {
//         if (isTierRewardGift(item)) updates[item.key] = 0;
//       });

//       if (Object.keys(updates).length) {
//         // PERFORMANCE: update.js already contains the full updated cart.
//         workingCart = await updateCartLines(updates);
//         changed = true;
//       }

//       return {
//         cart: workingCart,
//         changed,
//         eligibleTiers: []
//       };
//     }

//     const eligibleTiers = getEligibleGiftTiers(
//       configuration,
//       workingCart
//     );

//     let assignmentState = getGiftAssignments(
//       workingCart,
//       eligibleTiers
//     );

//     const updates = {};

//     assignmentState.giftLines.forEach((item) => {
//       if (!assignmentState.usedKeys.has(item.key)) {
//         updates[item.key] = 0;
//       }
//     });

//     assignmentState.assignments.forEach((item) => {
//       if (Number(item.quantity || 0) !== 1) {
//         updates[item.key] = 1;
//       }
//     });

//     if (Object.keys(updates).length) {
//       // PERFORMANCE: no follow-up GET is needed after a successful update.
//       workingCart = await updateCartLines(updates);
//       changed = true;

//       assignmentState = getGiftAssignments(
//         workingCart,
//         eligibleTiers
//       );
//     }

//     let giftWasAdded = false;

//     for (const tier of eligibleTiers) {
//       if (assignmentState.assignments.has(tier.id)) continue;

//       const failureSignature =
//         tier.id +
//         "::" +
//         tier.gift.expectedDiscountTitle +
//         "::" +
//         getCartSignature(workingCart);

//       if (
//         failureIsCoolingDown(
//           state.giftFailures,
//           tier.id,
//           failureSignature
//         )
//       ) {
//         continue;
//       }

//       try {
//         await addRewardGift(tier);
//         giftWasAdded = true;
//         changed = true;
//       } catch (error) {
//         if (error === STALE_REWARDS_PASS) throw error;

//         storeFailure(
//           state.giftFailures,
//           tier.id,
//           failureSignature,
//           error && error.message
//             ? error.message
//             : "Gift could not be added."
//         );

//         console.warn(
//           "[LGND Cart Drawer Rewards] " +
//             tier.title +
//             " could not be added:",
//           error
//         );

//         // An add error can leave a partial change; confirm before proceeding.
//         workingCart = await getCart();

//         assignmentState = getGiftAssignments(
//           workingCart,
//           eligibleTiers
//         );
//       }
//     }

//     if (giftWasAdded) {
//       // add.js returns added lines, not a full cart. Keep this confirmation
//       // read, but remove the artificial 100 ms wait.
//       workingCart = await getCart();
//     }

//     return {
//       cart: workingCart,
//       changed,
//       eligibleTiers
//     };
//   }

//   async function verifyGiftLines(cart, eligibleTiers) {
//     let workingCart = cart;
//     let changed = false;

//     const verifiedTierIds = new Set();
//     const assignmentState = getGiftAssignments(
//       workingCart,
//       eligibleTiers
//     );

//     const updates = {};

//     eligibleTiers.forEach((tier) => {
//       const item = assignmentState.assignments.get(tier.id);

//       if (rewardGiftIsVerified(item, tier)) {
//         verifiedTierIds.add(tier.id);
//         clearFailure(state.giftFailures, tier.id);
//         return;
//       }

//       if (!item) return;

//       updates[item.key] = 0;

//       const failureSignature =
//         tier.id +
//         "::" +
//         tier.gift.expectedDiscountTitle +
//         "::" +
//         getCartSignature(workingCart);

//       storeFailure(
//         state.giftFailures,
//         tier.id,
//         failureSignature,
//         "Shopify did not confirm the expected free-gift discount."
//       );

//       console.warn(
//         "[LGND Cart Drawer Rewards] " +
//           tier.title +
//           " was removed because Shopify did not make that tagged line free with " +
//           tier.gift.expectedDiscountTitle +
//           "."
//       );
//     });

//     if (Object.keys(updates).length) {
//       // PERFORMANCE: use the confirmed removal response directly.
//       workingCart = await updateCartLines(updates);
//       changed = true;
//     }

//     return {
//       cart: workingCart,
//       changed,
//       verifiedTierIds
//     };
//   }
//   // LGND CART DRAWER REWARDS — FREE PRODUCT RECONCILIATION END

//   // LGND CART DRAWER REWARDS — DISCOUNT CODE RECONCILIATION START
//   function addCode(codeMap, code) {
//     const displayCode = String(code || "").trim();
//     const normalized = normalizeCode(displayCode);

//     if (!normalized || codeMap.has(normalized)) return;

//     codeMap.set(normalized, displayCode);
//   }

//   function addDiscountApplication(codeMap, application) {
//     if (!application) return;

//     const type = String(application.type || "").toLowerCase();
//     if (type !== "discount_code") return;

//     addCode(codeMap, application.code || application.title);
//   }

//   function getAppliedCodes(cart, fallbackCodes = []) {
//     const codeMap = new Map();

//     const hasExplicitCodes = Boolean(
//       cart && Array.isArray(cart.discount_codes)
//     );

//     if (hasExplicitCodes) {
//       cart.discount_codes.forEach((discount) => {
//         if (!discount || discount.applicable === false) return;

//         addCode(codeMap, discount.code || discount.title);
//       });
//     }

//     [
//       cart && cart.discount_applications,
//       cart && cart.cart_level_discount_applications
//     ]
//       .filter(Array.isArray)
//       .forEach((applications) => {
//         applications.forEach((application) => {
//           addDiscountApplication(codeMap, application);
//         });
//       });

//     (
//       cart && Array.isArray(cart.items)
//         ? cart.items
//         : []
//     ).forEach((item) => {
//       const allocations = Array.isArray(
//         item.line_level_discount_allocations
//       )
//         ? item.line_level_discount_allocations
//         : Array.isArray(item.discount_allocations)
//           ? item.discount_allocations
//           : [];

//       allocations.forEach((allocation) => {
//         addDiscountApplication(
//           codeMap,
//           allocation.discount_application
//         );
//       });
//     });

//     if (!hasExplicitCodes && !codeMap.size) {
//       fallbackCodes.forEach((code) => {
//         addCode(codeMap, code);
//       });
//     }

//     return Array.from(codeMap.values());
//   }

//   function codeListHas(codes, code) {
//     const target = normalizeCode(code);

//     return Boolean(
//       target &&
//         codes.some((candidate) => {
//           return normalizeCode(candidate) === target;
//         })
//     );
//   }

//   function readStorage(storage, key) {
//     try {
//       return storage.getItem(key);
//     } catch (error) {
//       return null;
//     }
//   }

//   function writeStorage(storage, key, value) {
//     try {
//       if (value) {
//         storage.setItem(key, value);
//       } else {
//         storage.removeItem(key);
//       }
//     } catch (error) {
//       // Storage may be unavailable in private browsing; cart syncing continues.
//     }
//   }

//   function getStoredAutomaticCodes(cart) {
//     const storedValue =
//       readStorage(window.localStorage, STORED_CODES_KEY) ||
//       readStorage(window.localStorage, LEGACY_STORED_CODES_KEY);

//     if (!storedValue) return [];

//     try {
//       const parsed = JSON.parse(storedValue);

//       if (
//         parsed &&
//         parsed.cartToken &&
//         cart &&
//         cart.token &&
//         parsed.cartToken !== cart.token
//       ) {
//         return [];
//       }

//       if (parsed && Array.isArray(parsed.codes)) {
//         return uniqueValues(parsed.codes, normalizeCode);
//       }

//       if (parsed && parsed.code) {
//         return uniqueValues([parsed.code], normalizeCode);
//       }
//     } catch (error) {
//       return uniqueValues([storedValue], normalizeCode);
//     }

//     return [];
//   }

//   function setStoredAutomaticCodes(codes, cart) {
//     const storedCodes = uniqueValues(codes, normalizeCode);

//     writeStorage(
//       window.localStorage,
//       LEGACY_STORED_CODES_KEY,
//       ""
//     );

//     if (!storedCodes.length) {
//       writeStorage(
//         window.localStorage,
//         STORED_CODES_KEY,
//         ""
//       );

//       return;
//     }

//     writeStorage(
//       window.localStorage,
//       STORED_CODES_KEY,
//       JSON.stringify({
//         cartToken: cart && cart.token ? cart.token : null,
//         codes: storedCodes
//       })
//     );
//   }

//   function getCampaignPlan(
//     rewardsConfiguration,
//     timedConfiguration,
//     cart
//   ) {
//     const merchandiseItems = getMerchandiseItems(cart);
//     const qualifyingSubtotal = getQualifyingSubtotal(cart);

//     const selectedTierCodes = new Set();
//     const managedCodes = [];
//     const candidates = [];

//     if (rewardsConfiguration.enabled) {
//       rewardsConfiguration.tiers.forEach((tier) => {
//         if (tier.type !== "bonus_entries" || !tier.bonus.code) {
//           return;
//         }

//         selectedTierCodes.add(normalizeCode(tier.bonus.code));
//         managedCodes.push(tier.bonus.code);

//         if (
//           !tierBonusConfigurationIssue(tier.bonus) &&
//           qualifyingSubtotal >= tier.thresholdCents &&
//           campaignQualifies(tier.bonus, merchandiseItems)
//         ) {
//           candidates.push({
//             ...tier.bonus,
//             source: "tier",
//             tierId: tier.id,
//             thresholdCents: tier.thresholdCents
//           });
//         } else {
//           clearFailure(
//             state.codeFailures,
//             normalizeCode(tier.bonus.code)
//           );
//         }
//       });
//     }

//     timedConfiguration.campaigns.forEach((campaign) => {
//       if (campaign.autoApply) managedCodes.push(campaign.code);

//       if (selectedTierCodes.has(normalizeCode(campaign.code))) {
//         return;
//       }

//       if (
//         campaignIsActive(campaign) &&
//         campaignQualifies(campaign, merchandiseItems)
//       ) {
//         candidates.push({
//           ...campaign,
//           source: "timed",
//           tierId: "",
//           thresholdCents: 0
//         });
//       } else {
//         clearFailure(
//           state.codeFailures,
//           normalizeCode(campaign.code)
//         );
//       }
//     });

//     const candidatesByCode = new Map();

//     candidates
//       .sort((left, right) => {
//         if (left.source !== right.source) {
//           return left.source === "tier" ? -1 : 1;
//         }

//         return (
//           Number(left.thresholdCents || 0) -
//           Number(right.thresholdCents || 0)
//         );
//       })
//       .forEach((campaign) => {
//         const key = normalizeCode(campaign.code);

//         if (key && !candidatesByCode.has(key)) {
//           candidatesByCode.set(key, campaign);
//         }
//       });

//     return {
//       candidates: Array.from(candidatesByCode.values()),
//       managedCodes: uniqueValues(
//         [
//           ...managedCodes,
//           ...getStoredAutomaticCodes(cart)
//         ],
//         normalizeCode
//       )
//     };
//   }

//   async function reconcileDiscountCodes(
//     cart,
//     rewardsConfiguration,
//     timedConfiguration
//   ) {
//     const currentCodes = getAppliedCodes(
//       cart,
//       timedConfiguration.appliedDiscountCodes
//     );

//     const campaignPlan = getCampaignPlan(
//       rewardsConfiguration,
//       timedConfiguration,
//       cart
//     );

//     const managedKeys = new Set(
//       campaignPlan.managedCodes.map(normalizeCode)
//     );

//     const qualifiedKeys = new Set(
//       campaignPlan.candidates.map((campaign) => {
//         return normalizeCode(campaign.code);
//       })
//     );

//     const manualCodes = currentCodes.filter((code) => {
//       return !managedKeys.has(normalizeCode(code));
//     });

//     const existingQualifiedAutomaticCodes = currentCodes.filter((code) => {
//       const key = normalizeCode(code);

//       return managedKeys.has(key) && qualifiedKeys.has(key);
//     });

//     const orderedCandidates = [
//       ...campaignPlan.candidates.filter((campaign) => {
//         return codeListHas(
//           existingQualifiedAutomaticCodes,
//           campaign.code
//         );
//       }),
//       ...campaignPlan.candidates.filter((campaign) => {
//         return !codeListHas(
//           existingQualifiedAutomaticCodes,
//           campaign.code
//         );
//       })
//     ];

//     const availableSlots = Math.max(
//       0,
//       MAX_DISCOUNT_CODES - manualCodes.length
//     );

//     const automaticCodes = [];
//     const attemptedCampaigns = [];

//     state.skippedCodes = new Set();

//     orderedCandidates.forEach((campaign) => {
//       const key = normalizeCode(campaign.code);

//       if (!key || codeListHas(automaticCodes, campaign.code)) {
//         return;
//       }

//       if (automaticCodes.length >= availableSlots) {
//         state.skippedCodes.add(key);
//         return;
//       }

//       if (codeListHas(currentCodes, campaign.code)) {
//         automaticCodes.push(campaign.code);
//         return;
//       }

//       const failureSignature =
//         key +
//         "::" +
//         getCartSignature(cart) +
//         "::" +
//         manualCodes.map(normalizeCode).sort().join("|");

//       if (
//         failureIsCoolingDown(
//           state.codeFailures,
//           key,
//           failureSignature
//         )
//       ) {
//         return;
//       }

//       automaticCodes.push(campaign.code);
//       attemptedCampaigns.push({
//         campaign,
//         failureSignature
//       });
//     });

//     const targetCodes = uniqueValues(
//       [...manualCodes, ...automaticCodes],
//       normalizeCode
//     );

//     let resultingCart = cart;
//     let resultingCodes = currentCodes;

//     if (!valuesMatch(currentCodes, targetCodes, normalizeCode)) {
//       resultingCart = await updateDiscountCodes(targetCodes);
//       resultingCodes = getAppliedCodes(resultingCart);

//       const attemptedCodeMissing = attemptedCampaigns.some(
//         ({ campaign }) => {
//           return !codeListHas(resultingCodes, campaign.code);
//         }
//       );

//       if (attemptedCodeMissing) {
//         await wait(REJECTION_VERIFICATION_DELAY_MS);

//         resultingCart = await getCart();
//         resultingCodes = getAppliedCodes(resultingCart);
//       }

//       const missingManualCodes = manualCodes.filter((code) => {
//         return !codeListHas(resultingCodes, code);
//       });

//       if (missingManualCodes.length) {
//         const rollbackCodes = uniqueValues(
//           [
//             ...manualCodes,
//             ...existingQualifiedAutomaticCodes
//           ],
//           normalizeCode
//         );

//         resultingCart = await updateDiscountCodes(rollbackCodes);

//         await wait(REJECTION_VERIFICATION_DELAY_MS);

//         resultingCart = await getCart();
//         resultingCodes = getAppliedCodes(resultingCart);

//         attemptedCampaigns.forEach(
//           ({ campaign, failureSignature }) => {
//             storeFailure(
//               state.codeFailures,
//               normalizeCode(campaign.code),
//               failureSignature,
//               "The reward code conflicted with an existing customer discount."
//             );
//           }
//         );

//         console.warn(
//           "[LGND Cart Drawer Rewards] Automatic reward codes were rolled back so an existing customer discount would not be removed."
//         );
//       } else {
//         const rejectedAttemptExists = attemptedCampaigns.some(
//           ({ campaign }) => {
//             return !codeListHas(resultingCodes, campaign.code);
//           }
//         );

//         if (rejectedAttemptExists) {
//           // Remove non-applicable raw codes from Shopify's discount_codes array
//           // so failed $0 markers do not linger or consume a code slot.
//           const cleanCodes = targetCodes.filter((code) => {
//             return codeListHas(resultingCodes, code);
//           });

//           if (!valuesMatch(targetCodes, cleanCodes, normalizeCode)) {
//             resultingCart = await updateDiscountCodes(cleanCodes);
//             resultingCart = await getCart();
//             resultingCodes = getAppliedCodes(resultingCart);
//           }
//         }
//       }
//     }

//     attemptedCampaigns.forEach(
//       ({ campaign, failureSignature }) => {
//         const key = normalizeCode(campaign.code);

//         if (codeListHas(resultingCodes, campaign.code)) {
//           clearFailure(state.codeFailures, key);
//           return;
//         }

//         storeFailure(
//           state.codeFailures,
//           key,
//           failureSignature,
//           "Shopify did not report this reward code as applicable."
//         );

//         console.warn(
//           "[LGND Cart Drawer Rewards] " +
//             campaign.code +
//             " was attempted but Shopify did not report it as applicable."
//         );
//       }
//     );

//     const appliedAutomaticCodes = campaignPlan.candidates
//       .map((campaign) => campaign.code)
//       .filter((code) => codeListHas(resultingCodes, code));

//     setStoredAutomaticCodes(
//       appliedAutomaticCodes,
//       resultingCart
//     );

//     return {
//       cart: resultingCart,
//       changed: !valuesMatch(
//         currentCodes,
//         resultingCodes,
//         normalizeCode
//       ),
//       currentCodes,
//       resultingCodes,
//       appliedAutomaticCodes,
//       targetCodes
//     };
//   }
//   // LGND CART DRAWER REWARDS — DISCOUNT CODE RECONCILIATION END

//   // LGND CART DRAWER REWARDS — PROGRESS AND REWARD ROW UI START
//   function formatMoney(cents, currencyCode) {
//     const numericCents = Math.max(
//       0,
//       Math.round(Number(cents || 0))
//     );

//     const hasFraction = numericCents % 100 !== 0;

//     try {
//       return new Intl.NumberFormat(
//         document.documentElement.lang || "en-US",
//         {
//           style: "currency",
//           currency: currencyCode || "USD",
//           currencyDisplay: "narrowSymbol",
//           minimumFractionDigits: hasFraction ? 2 : 0,
//           maximumFractionDigits: hasFraction ? 2 : 0
//         }
//       ).format(numericCents / 100);
//     } catch (error) {
//       return (
//         (numericCents / 100).toFixed(hasFraction ? 2 : 0) +
//         " " +
//         (currencyCode || "USD")
//       );
//     }
//   }

//   function replaceMessageTokens(template, amount, reward) {
//     return String(template || "")
//       .split("[amount]")
//       .join(amount)
//       .split("[reward]")
//       .join(reward);
//   }

//   // LGND CART DRAWER REWARDS — BALANCED MILESTONES START
//   function getBalancedTierPosition(
//     index,
//     tierCount,
//     firstMilestoneOffset
//   ) {
//     if (index < 0 || tierCount <= 0) return 0;
//     if (tierCount === 1) return 100;

//     const offset = Math.max(
//       0,
//       Math.min(Number(firstMilestoneOffset || 0), 25)
//     );

//     return offset + (index / (tierCount - 1)) * (100 - offset);
//   }

//   function getBalancedTierProgress(
//     visibleTiers,
//     qualifyingSubtotal,
//     firstMilestoneOffset
//   ) {
//     if (!visibleTiers.length) return 0;

//     let previousThreshold = 0;
//     let previousPosition = 0;

//     for (let index = 0; index < visibleTiers.length; index += 1) {
//       const threshold = Math.max(
//         previousThreshold,
//         Number(visibleTiers[index].thresholdCents || 0)
//       );

//       const targetPosition = getBalancedTierPosition(
//         index,
//         visibleTiers.length,
//         firstMilestoneOffset
//       );

//       if (qualifyingSubtotal < threshold) {
//         const thresholdRange = threshold - previousThreshold;

//         const progressWithinSegment =
//           thresholdRange > 0
//             ? Math.max(
//                 0,
//                 Math.min(
//                   (
//                     qualifyingSubtotal - previousThreshold
//                   ) / thresholdRange,
//                   1
//                 )
//               )
//             : 0;

//         return Math.min(
//           100,
//           previousPosition +
//             progressWithinSegment *
//               (targetPosition - previousPosition)
//         );
//       }

//       previousThreshold = threshold;
//       previousPosition = targetPosition;
//     }

//     return 100;
//   }
//   // LGND CART DRAWER REWARDS — BALANCED MILESTONES END

//   function getTierStates(configuration, cart, visibleTiers) {
//     const qualifyingSubtotal = getQualifyingSubtotal(cart);
//     const appliedCodes = getAppliedCodes(cart);

//     const giftTiers = visibleTiers.filter((tier) => {
//       return tier.type === "free_gift";
//     });

//     const giftAssignments = getGiftAssignments(
//       cart,
//       giftTiers
//     ).assignments;

//     return visibleTiers.map((tier) => {
//       const spendReached = tierSpendIsReached(
//         tier,
//         configuration,
//         cart,
//         qualifyingSubtotal
//       );

//       let unlocked = spendReached;
//       let invalid = false;
//       let pending = false;

//       if (tier.type === "free_gift") {
//         const item = giftAssignments.get(tier.id);

//         unlocked =
//           spendReached &&
//           rewardGiftIsVerified(item, tier);

//         invalid =
//           spendReached &&
//           (
//             Boolean(giftConfigurationIssue(tier)) ||
//             state.giftFailures.has(tier.id)
//           );

//         pending =
//           spendReached &&
//           !unlocked &&
//           !invalid &&
//           state.syncing;
//       }

//       if (tier.type === "bonus_entries") {
//         const codeKey = normalizeCode(tier.bonus.code);

//         unlocked =
//           spendReached &&
//           !tierBonusConfigurationIssue(tier.bonus) &&
//           campaignQualifies(
//             tier.bonus,
//             getMerchandiseItems(cart)
//           ) &&
//           codeListHas(appliedCodes, tier.bonus.code);

//         invalid =
//           spendReached &&
//           (
//             Boolean(tierBonusConfigurationIssue(tier.bonus)) ||
//             state.codeFailures.has(codeKey) ||
//             state.skippedCodes.has(codeKey)
//           );

//         pending =
//           spendReached &&
//           !unlocked &&
//           !invalid &&
//           state.syncing;
//       }

//       if (tier.type === "free_shipping") {
//         invalid = false;
//         pending = false;
//       }

//       return {
//         tier,
//         spendReached,
//         unlocked,
//         invalid,
//         pending
//       };
//     });
//   }

//   function getRewardNotice(tierStates) {
//     const invalidState = tierStates.find((tierState) => {
//       return tierState.invalid;
//     });

//     if (!invalidState) return "";

//     if (invalidState.tier.type === "free_gift") {
//       return (
//         invalidState.tier.title +
//         " could not be confirmed as free, so it was not added to your cart."
//       );
//     }

//     if (invalidState.tier.type === "bonus_entries") {
//       if (
//         state.skippedCodes.has(
//           normalizeCode(invalidState.tier.bonus.code)
//         )
//       ) {
//         return (
//           invalidState.tier.title +
//           " could not be applied because this cart already has the maximum number of discount codes."
//         );
//       }

//       return (
//         invalidState.tier.title +
//         " could not be applied. Your existing cart discounts were left unchanged."
//       );
//     }

//     return "";
//   }

//   function updateRewardRows(configuration, tierStates) {
//     const stateById = new Map(
//       tierStates.map((tierState) => {
//         return [tierState.tier.id, tierState];
//       })
//     );

//     document.querySelectorAll("[data-lgnd-reward-row]").forEach((row) => {
//       const tierState = stateById.get(
//         String(row.dataset.rewardId || "")
//       );

//       const shouldShow = Boolean(
//         configuration.enabled &&
//           tierState &&
//           tierState.unlocked &&
//           tierState.tier.type !== "free_gift"
//       );

//       row.hidden = !shouldShow;

//       if (!shouldShow) return;

//       const status = row.querySelector(
//         "[data-lgnd-reward-row-status]"
//       );

//       if (!status) return;

//       if (
//         tierState.tier.type === "free_shipping" &&
//         configuration.member &&
//         tierState.tier.memberOverride
//       ) {
//         status.textContent = configuration.messages.memberShipping;
//       } else if (tierState.tier.type === "bonus_entries") {
//         status.textContent =
//           tierState.tier.bonus.code + " applied";
//       } else {
//         status.textContent = "Unlocked";
//       }
//     });
//   }

//   function updateRewardUI(cart) {
//     const configuration = readRewardsConfiguration();
//     const roots = document.querySelectorAll(REWARDS_ROOT_SELECTOR);

//     if (!cart || !configuration.enabled || !configuration.tiers.length) {
//       roots.forEach((root) => {
//         root.hidden = true;
//       });

//       document.querySelectorAll("[data-lgnd-reward-row]").forEach((row) => {
//         row.hidden = true;
//       });

//       return;
//     }

//     const visibleTiers = getVisibleTiers(configuration, cart);

//     const tierStates = getTierStates(
//       configuration,
//       cart,
//       visibleTiers
//     );

//     const stateById = new Map(
//       tierStates.map((tierState) => {
//         return [tierState.tier.id, tierState];
//       })
//     );

//     const qualifyingSubtotal = getQualifyingSubtotal(cart);

//     const allUnlocked =
//       tierStates.length > 0 &&
//       tierStates.every((tierState) => tierState.unlocked);

//     let progress = getBalancedTierProgress(
//       visibleTiers,
//       qualifyingSubtotal,
//       configuration.firstMilestoneOffset
//     );

//     if (allUnlocked) progress = 100;

//     roots.forEach((root) => {
//       if (!visibleTiers.length) {
//         root.hidden = true;
//         return;
//       }

//       root.hidden = false;

//       root.style.setProperty(
//         "--lgnd-rewards-progress",
//         progress + "%"
//       );

//       const track = root.querySelector(
//         "[data-lgnd-rewards-track]"
//       );

//       if (track) {
//         track.setAttribute(
//           "aria-valuenow",
//           String(Math.round(progress))
//         );
//       }

//       root.querySelectorAll("[data-lgnd-reward-milestone]").forEach(
//         (milestone) => {
//           const tierId = String(
//             milestone.dataset.rewardId || ""
//           );

//           const tierState = stateById.get(tierId);

//           milestone.hidden = !tierState;

//           milestone.classList.toggle(
//             "is-unlocked",
//             Boolean(tierState && tierState.unlocked)
//           );

//           milestone.classList.toggle(
//             "is-invalid",
//             Boolean(tierState && tierState.invalid)
//           );

//           milestone.classList.toggle(
//             "is-pending",
//             Boolean(tierState && tierState.pending)
//           );

//           if (!tierState) return;

//           const tierIndex = visibleTiers.findIndex((tier) => {
//             return tier.id === tierId;
//           });

//           const position = getBalancedTierPosition(
//             tierIndex,
//             visibleTiers.length,
//             configuration.firstMilestoneOffset
//           );

//           milestone.style.setProperty(
//             "--lgnd-reward-position",
//             position + "%"
//           );

//           milestone.dataset.rewardState = tierState.invalid
//             ? "invalid"
//             : tierState.unlocked
//               ? "unlocked"
//               : tierState.pending
//                 ? "pending"
//                 : "locked";

//           const title = milestone.querySelector(
//             ".lgnd-cart-rewards__milestone-title"
//           );

//           const thresholdLabel = milestone.querySelector(
//             "[data-lgnd-reward-threshold-label]"
//           );

//           if (title) {
//             title.textContent = tierState.tier.title;
//           }

//           if (thresholdLabel) {
//             thresholdLabel.textContent = formatMoney(
//               tierState.tier.thresholdCents,
//               configuration.presentmentCurrency
//             );
//           }
//         }
//       );

//       const message = root.querySelector(
//         "[data-lgnd-rewards-message]"
//       );

//       const notice = root.querySelector(
//         "[data-lgnd-rewards-notice]"
//       );

//       const nextState = tierStates.find((tierState) => {
//         return !tierState.unlocked;
//       });

//       let messageText = configuration.messages.complete;

//       if (nextState) {
//         const basis =
//           nextState.tier.type === "free_shipping"
//             ? Math.max(0, Number(cart.total_price || 0))
//             : qualifyingSubtotal;

//         const remaining = Math.max(
//           nextState.tier.thresholdCents - basis,
//           0
//         );

//         if (nextState.invalid) {
//           messageText =
//             nextState.tier.title + " is temporarily unavailable.";
//         } else if (nextState.pending || remaining === 0) {
//           messageText =
//             nextState.tier.type === "free_gift"
//               ? "Adding " + nextState.tier.title + "…"
//               : "Applying " + nextState.tier.title + "…";
//         } else {
//           messageText = replaceMessageTokens(
//              configuration.messages.next,
//              formatMoney(remaining, configuration.presentmentCurrency),
//              nextState.tier.type === "free_gift" ? "a " + nextState.tier.title  : nextState.tier.title
//           );
//         }
//       } else {
//         const memberShippingState = tierStates.find((tierState) => {
//           return (
//             tierState.tier.type === "free_shipping" &&
//             tierState.tier.memberOverride &&
//             configuration.member
//           );
//         });

//         if (memberShippingState && tierStates.length === 1) {
//           messageText = configuration.messages.memberShipping;
//         }
//       }

//       if (message) {
//         message.textContent = messageText;

//         if (track) {
//           track.setAttribute("aria-valuetext", messageText);
//         }
//       }

//       const noticeText = getRewardNotice(tierStates);

//       if (notice) {
//         notice.hidden = !noticeText;
//         notice.textContent = noticeText;
//       }
//     });

//     updateRewardRows(configuration, tierStates);
//   }
//   // LGND CART DRAWER REWARDS — PROGRESS AND REWARD ROW UI END

//   // LGND CART DRAWER REWARDS — SYNCHRONIZED CONTROLLER START
//   // PERFORMANCE: confirmed snapshots, shared reads and stale-pass protection.
//   const STALE_REWARDS_PASS = Symbol("stale rewards pass");

//   const syncControl = {
//     epoch: 0,
//     runEpoch: 0,
//     revision: 0,
//     pendingMutations: 0,
//     writing: false,
//     snapshot: null,
//     reads: new Set(),
//     knownCarts: new Map(),
//     sections: null,
//     displayDirty: false,
//     timerDue: 0
//   };

//   function isCompleteCart(cart) {
//     return Boolean(
//       cart &&
//         Array.isArray(cart.items) &&
//         typeof cart.item_count === "number" &&
//         typeof cart.total_price === "number"
//     );
//   }

//   function cartSnapshotKey(cart) {
//     // Section HTML is presentation only and may be attached by Prestige later.
//     return JSON.stringify({
//       ...cart,
//       sections: undefined
//     });
//   }

//   function rememberCart(cart, revision) {
//     if (!isCompleteCart(cart)) return;

//     const key = cartSnapshotKey(cart);

//     syncControl.knownCarts.delete(key);
//     syncControl.knownCarts.set(key, revision);

//     if (syncControl.knownCarts.size > 12) {
//       syncControl.knownCarts.delete(
//         syncControl.knownCarts.keys().next().value
//       );
//     }
//   }

//   function assertCurrentPass() {
//     if (
//       state.syncing &&
//       (
//         syncControl.runEpoch !== syncControl.epoch ||
//         syncControl.pendingMutations > 0
//       )
//     ) {
//       state.syncQueued = true;
//       throw STALE_REWARDS_PASS;
//     }
//   }

//   function invalidateCart() {
//     syncControl.epoch += 1;
//     syncControl.revision += 1;
//     syncControl.snapshot = null;
//     syncControl.sections = null;

//     state.latestCart = null;
//     state.syncQueued = true;

//     setCheckoutPending(true);
//   }

//   function acceptCart(cart) {
//     if (!isCompleteCart(cart)) return;

//     rememberCart(cart, syncControl.revision);

//     syncControl.snapshot = {
//       cart,
//       revision: syncControl.revision
//     };

//     state.latestCart = cart;
//     updateRewardUI(cart);
//   }

//   async function getStartingCart() {
//     assertCurrentPass();

//     if (
//       syncControl.snapshot &&
//       syncControl.snapshot.revision === syncControl.revision
//     ) {
//       return syncControl.snapshot.cart;
//     }

//     // Prestige reads cart.js after add.js. Share that in-flight read if present.
//     const read = Array.from(syncControl.reads).find((entry) => {
//       return (
//         entry.revision === syncControl.revision &&
//         !entry.duringRewardWrite
//       );
//     });

//     if (read) {
//       const cart = await read.promise;
//       assertCurrentPass();

//       if (
//         read.revision === syncControl.revision &&
//         isCompleteCart(cart)
//       ) {
//         return cart;
//       }
//     }

//     return getCart();
//   }

//   function getRewardSectionIds() {
//     if (!document.querySelector("cart-drawer")) return [];

//     const sections = [];

//     document.dispatchEvent(
//       new CustomEvent("cart:prepare-bundled-sections", {
//         bubbles: true,
//         detail: { sections }
//       })
//     );

//     const ids = [
//       ...new Set(
//         sections.filter((id) => {
//           return typeof id === "string" && id.length > 0;
//         })
//       )
//     ];

//     // Shopify supports five. Use the normal refresh if a theme needs more.
//     return ids.length <= 5 ? ids : [];
//   }

//   function scheduleDateBoundary(
//     rewardsConfiguration,
//     timedConfiguration
//   ) {
//     window.clearTimeout(state.boundaryTimer);
//     state.boundaryTimer = 0;

//     const now = Date.now();

//     const selectedCodes = new Set(
//       rewardsConfiguration.enabled
//         ? rewardsConfiguration.tiers
//             .filter((tier) => tier.type === "bonus_entries")
//             .map((tier) => normalizeCode(tier.bonus.code))
//         : []
//     );

//     const boundaries = [];

//     // Tier-selected campaigns are spend-driven; only standalone promos need timers.
//     timedConfiguration.campaigns.forEach((campaign) => {
//       if (
//         !campaign ||
//         !campaign.autoApply ||
//         selectedCodes.has(normalizeCode(campaign.code))
//       ) {
//         return;
//       }

//       if (campaign.startsAt > now) {
//         boundaries.push(campaign.startsAt);
//       }

//       if (campaign.endsAt >= now) {
//         boundaries.push(campaign.endsAt + 1000);
//       }
//     });

//     if (!boundaries.length) return;

//     const delay = Math.min(
//       Math.max(Math.min(...boundaries) - now, 250),
//       2147483000
//     );

//     state.boundaryTimer = window.setTimeout(() => {
//       invalidateCart();
//       scheduleSync(0);
//     }, delay);
//   }

//   function setCheckoutPending(pending) {
//     document
//       .querySelectorAll(
//         'button[name="checkout"], input[name="checkout"]'
//       )
//       .forEach((checkoutControl) => {
//         if (pending) {
//           if (!checkoutControl.disabled) {
//             checkoutControl.dataset.lgndRewardsLock = "true";
//             checkoutControl.disabled = true;
//           }

//           checkoutControl.setAttribute("aria-busy", "true");
//           return;
//         }

//         checkoutControl.removeAttribute("aria-busy");

//         if (checkoutControl.dataset.lgndRewardsLock === "true") {
//           checkoutControl.disabled = false;
//           delete checkoutControl.dataset.lgndRewardsLock;
//         }
//       });
//   }

//   function refreshCartDisplay(cart) {
//     if (/\/cart\/?$/.test(window.location.pathname)) {
//       window.location.reload();
//       return;
//     }

//     const bundle = syncControl.sections;

//     let validBundle = Boolean(
//       bundle &&
//         bundle.revision === syncControl.revision &&
//         bundle.ids.length &&
//         bundle.ids.every((id) => {
//           return (
//             typeof bundle.values[id] === "string" &&
//             bundle.values[id].trim()
//           );
//         })
//     );

//     if (validBundle) {
//       // A null/missing section must never be passed to Prestige's parser.
//       validBundle = bundle.ids.some((id) => {
//         return new DOMParser()
//           .parseFromString(bundle.values[id], "text/html")
//           .querySelector("cart-drawer");
//       });
//     }

//     if (validBundle) {
//       document.dispatchEvent(
//         new CustomEvent("cart:change", {
//           bubbles: true,
//           detail: {
//             source: CONTROLLER_SOURCE,
//             baseEvent: "rewards:sync",
//             cart: {
//               ...cart,
//               sections: bundle.values
//             }
//           }
//         })
//       );
//     } else {
//       document.dispatchEvent(
//         new CustomEvent("cart:refresh", {
//           bubbles: true,
//           detail: {
//             source: CONTROLLER_SOURCE
//           }
//         })
//       );
//     }

//     document.dispatchEvent(
//       new CustomEvent("cart:updated", {
//         bubbles: true,
//         detail: {
//           source: CONTROLLER_SOURCE,
//           cart
//         }
//       })
//     );
//   }

//   async function synchronizeCartRewards() {
//     const rewardsConfiguration = readRewardsConfiguration();
//     const timedConfiguration = readTimedBonusConfiguration();

//     scheduleDateBoundary(
//       rewardsConfiguration,
//       timedConfiguration
//     );

//     let cart = await getStartingCart();
//     assertCurrentPass();

//     // Paint the real spend immediately; rewards remain pending until confirmed.
//     acceptCart(cart);

//     const giftReconciliation = await reconcileGiftLines(
//       cart,
//       rewardsConfiguration
//     );

//     assertCurrentPass();
//     cart = giftReconciliation.cart;

//     const firstGiftVerification = await verifyGiftLines(
//       cart,
//       giftReconciliation.eligibleTiers
//     );

//     assertCurrentPass();
//     cart = firstGiftVerification.cart;
//     acceptCart(cart);

//     const discountReconciliation = await reconcileDiscountCodes(
//       cart,
//       rewardsConfiguration,
//       timedConfiguration
//     );

//     assertCurrentPass();
//     cart = discountReconciliation.cart;

//     // Keep the second check: a bonus discount can invalidate a free-gift discount.
//     const finalGiftVerification = await verifyGiftLines(
//       cart,
//       giftReconciliation.eligibleTiers
//     );

//     assertCurrentPass();
//     cart = finalGiftVerification.cart;

//     state.report = {
//       checkedAt: new Date().toISOString(),
//       qualifyingSubtotal: getQualifyingSubtotal(cart),
//       postDiscountTotal: Number(cart.total_price || 0),
//       appliedCodes: getAppliedCodes(cart),
//       verifiedGiftTierIds: Array.from(
//         finalGiftVerification.verifiedTierIds
//       ),
//       rewardsConfigurationErrors: rewardsConfiguration.errors,
//       timedConfigurationErrors: timedConfiguration.errors
//     };

//     acceptCart(cart);

//     if (syncControl.displayDirty) {
//       syncControl.displayDirty = false;
//       refreshCartDisplay(cart);
//     }
//   }

//   async function runSyncQueue() {
//     window.clearTimeout(state.syncTimer);
//     state.syncTimer = 0;
//     syncControl.timerDue = 0;

//     if (state.syncing || syncControl.pendingMutations) return;

//     state.syncing = true;
//     setCheckoutPending(true);

//     try {
//       do {
//         state.syncQueued = false;
//         syncControl.runEpoch = syncControl.epoch;

//         try {
//           await synchronizeCartRewards();
//         } catch (error) {
//           if (error === STALE_REWARDS_PASS) {
//             state.syncQueued = true;
//           } else {
//             // Do not reuse a cart from a partially completed/failed pass.
//             syncControl.snapshot = null;
//             state.latestCart = null;

//             console.warn(
//               "[LGND Cart Drawer Rewards] Sync failed:",
//               error
//             );

//             if (syncControl.displayDirty) {
//               syncControl.sections = null;
//               syncControl.displayDirty = false;
//               refreshCartDisplay(null);
//             }
//           }
//         }
//       } while (
//         state.syncQueued &&
//         !syncControl.pendingMutations
//       );
//     } finally {
//       state.syncing = false;

//       const pending =
//         state.syncQueued ||
//         syncControl.pendingMutations > 0;

//       setCheckoutPending(pending);

//       if (state.latestCart) {
//         updateRewardUI(state.latestCart);
//       }

//       if (state.syncQueued && !syncControl.pendingMutations) {
//         scheduleSync(0);
//       }
//     }
//   }

//   function scheduleSync(delay = 0) {
//     state.syncQueued = true;
//     setCheckoutPending(true);

//     if (state.syncing || syncControl.pendingMutations) return;

//     const due = Date.now() + delay;

//     // Duplicate event notifications must not keep pushing the timer back.
//     if (
//       state.syncTimer &&
//       syncControl.timerDue <= due
//     ) {
//       return;
//     }

//     window.clearTimeout(state.syncTimer);

//     syncControl.timerDue = due;
//     state.syncTimer = window.setTimeout(runSyncQueue, delay);
//   }

//   function getRequestUrl(request) {
//     if (typeof request === "string") return request;
//     if (request && request.url) return request.url;
//     if (request instanceof URL) return request.href;

//     return "";
//   }

//   // Route Code Edited 9/11/2026
//   // Identifies a cart/add.js response as Route-only by handle, not title —
//   // isRouteProtection() matches on display title and can drift if the
//   // merchant renames the line item. Used only to skip the reward-sync
//   // pass below; does not replace isRouteProtection elsewhere in this file.
//   function isRouteAddResponse(cart) {
//     const items = Array.isArray(cart && cart.items)
//       ? cart.items
//       : (cart && cart.handle ? [cart] : []);

//     return items.length > 0 && items.every((item) => item.handle === ROUTE_HANDLE);
//   }
//   // End Route Code

//   function finishObservedMutation(record, response, cart) {
//     syncControl.pendingMutations -= 1;

//     const reliable =
//       record.revision === syncControl.revision &&
//       !record.overlapped &&
//       !syncControl.pendingMutations;

//     if (!reliable) {
//       // Overlapping requests can finish out of order. Resolve with a fresh GET.
//       syncControl.revision += 1;
//       syncControl.snapshot = null;
//       state.latestCart = null;
//     }

//     rememberCart(
//       cart,
//       reliable ? syncControl.revision : -1
//     );

//     // Route Code Edited 9/11/2026
//     // Route's line item is already excluded from qualifying merchandise
//     // (isTopLevelMerchandise -> isRouteProtection), so a mutation that only
//     // adds/removes it can't change gift or discount eligibility. Skip the
//     // reward-sync pass and release checkout instead of running the full
//     // pipeline for a no-op result.
//     if (
//       reliable &&
//       response &&
//       response.ok &&
//       !syncControl.pendingMutations &&
//       isRouteAddResponse(cart)
//     ) {
//       setCheckoutPending(false);
//       return;
//     }
//     // End Route Code

//     if (
//       reliable &&
//       response &&
//       response.ok &&
//       isCompleteCart(cart)
//     ) {
//       acceptCart(cart);
//     }

//     // Only partial add responses get a short fallback window for Prestige's GET.
//     scheduleSync(
//       reliable &&
//       response &&
//       response.ok &&
//       !isCompleteCart(cart)
//         ? 40
//         : 0
//     );
//   }

//   // Observe responses without delaying or consuming the caller's Response body.
//   window.fetch = (...args) => {
//     let url;

//     try {
//       url = new URL(
//         getRequestUrl(args[0]),
//         window.location.href
//       );
//     } catch (error) {
//       return originalFetch(...args);
//     }

//     const method = String(
//       (args[1] && args[1].method) ||
//         (args[0] && args[0].method) ||
//         "GET"
//     ).toUpperCase();

//     const sameOrigin =
//       url.origin === window.location.origin;

//     const isMutation =
//       sameOrigin &&
//       method !== "GET" &&
//       method !== "HEAD" &&
//       CART_MUTATION_PATTERN.test(url.pathname);

//     const isCartRead =
//       sameOrigin &&
//       method === "GET" &&
//       /\/cart\.js$/.test(url.pathname);

//     if (!isMutation && !isCartRead) {
//       return originalFetch(...args);
//     }

//     const overlapped =
//       syncControl.pendingMutations > 0 ||
//       syncControl.writing;

//     if (isMutation) {
//       invalidateCart();
//       syncControl.pendingMutations += 1;
//     }

//     const record = {
//       revision: syncControl.revision,
//       overlapped,
//       duringRewardWrite: syncControl.writing,
//       promise: null
//     };

//     const request = originalFetch(...args);

//     record.promise = request
//       .then(
//         async (response) => {
//           let cart = null;

//           try {
//             cart = await response.clone().json();
//           } catch (error) {}

//           if (isMutation) {
//             finishObservedMutation(
//               record,
//               response,
//               cart
//             );
//           } else {
//             rememberCart(
//               cart,
//               record.duringRewardWrite
//                 ? -1
//                 : record.revision
//             );

//             if (
//               response.ok &&
//               record.revision === syncControl.revision &&
//               !record.duringRewardWrite &&
//               !syncControl.pendingMutations &&
//               !syncControl.writing &&
//               isCompleteCart(cart)
//             ) {
//               // A background read can reveal an app/other-tab change we did not see.
//               const changed =
//                 !syncControl.snapshot ||
//                 cartSnapshotKey(syncControl.snapshot.cart) !==
//                   cartSnapshotKey(cart);

//               acceptCart(cart);

//               if (
//                 !state.syncing &&
//                 (state.syncQueued || changed)
//               ) {
//                 scheduleSync(0);
//               }
//             }
//           }

//           return response.ok &&
//             !record.duringRewardWrite &&
//             isCompleteCart(cart)
//             ? cart
//             : null;
//         },
//         () => {
//           if (isMutation) {
//             finishObservedMutation(
//               record,
//               null,
//               null
//             );
//           }

//           return null;
//         }
//       )
//       .catch((error) => {
//         // Observer failures must never reject the theme/app's own request.
//         console.warn(
//           "[LGND Cart Drawer Rewards] Cart observer failed:",
//           error
//         );

//         return null;
//       })
//       .finally(() => {
//         syncControl.reads.delete(record);
//       });

//     if (isCartRead) {
//       syncControl.reads.add(record);
//     }

//     return request;
//   };

//   function eventCameFromController(event) {
//     return Boolean(
//       event &&
//         event.detail &&
//         event.detail.source === CONTROLLER_SOURCE
//     );
//   }

//   function onCartEvent(event) {
//     if (eventCameFromController(event)) return;

//     const cart = event.detail && event.detail.cart;

//     if (isCompleteCart(cart)) {
//       const knownRevision = syncControl.knownCarts.get(
//         cartSnapshotKey(cart)
//       );

//       if (knownRevision !== undefined) {
//         if (
//           knownRevision === syncControl.revision &&
//           !syncControl.pendingMutations &&
//           !syncControl.writing
//         ) {
//           acceptCart(cart);

//           if (state.syncQueued && !state.syncing) {
//             scheduleSync(0);
//           }
//         }

//         return; // Duplicate or stale event; never start another full pass for it.
//       }

//       // The response observer will publish the payload after parsing finishes.
//       if (
//         syncControl.pendingMutations ||
//         syncControl.reads.size
//       ) {
//         return;
//       }

//       // Support app/XHR producers that emit a full cart without using fetch.
//       const overlapped = syncControl.writing;

//       invalidateCart();

//       if (!overlapped) {
//         acceptCart(cart);
//       }

//       scheduleSync(0);
//       return;
//     }

//     // Coalesce payload-free notifications into any already scheduled work.
//     if (
//       state.syncQueued ||
//       syncControl.pendingMutations
//     ) {
//       return;
//     }

//     invalidateCart();
//     scheduleSync(0);
//   }

//   document.addEventListener(
//     "cart:change",
//     onCartEvent
//   );

//   document.addEventListener(
//     "cart:refresh",
//     onCartEvent
//   );

//   document.addEventListener(
//     "cart:updated",
//     onCartEvent
//   );

//   document.addEventListener("cart-drawer:refreshed", () => {
//     setCheckoutPending(
//       state.syncing ||
//         state.syncQueued ||
//         syncControl.pendingMutations > 0
//     );

//     if (state.latestCart) {
//       updateRewardUI(state.latestCart);
//     }
//   });

//   function requestFreshSync() {
//     invalidateCart();
//     scheduleSync(0);
//   }

//   document.addEventListener(
//     "shopify:section:load",
//     requestFreshSync
//   );

//   window.addEventListener(
//     "online",
//     requestFreshSync
//   );

//   window.addEventListener("pageshow", (event) => {
//     if (event.persisted) {
//       requestFreshSync();
//     }
//   });

//   function initialize() {
//     scheduleFailureRetry();
//     scheduleSync(0);
//   }

//   window.LGNDCartDrawerRewards = {
//     refresh: requestFreshSync,
//     getReport: () => state.report
//   };

//   if (document.readyState === "loading") {
//     document.addEventListener(
//       "DOMContentLoaded",
//       initialize,
//       { once: true }
//     );
//   } else {
//     initialize();
//   }
//   // LGND CART DRAWER REWARDS — SYNCHRONIZED CONTROLLER END
// })();


/**
 * LGND CART DRAWER REWARDS
 *
 * Shared cart controller for:
 * - cumulative spend-tier progress;
 * - Buy X Get Y product gifts;
 * - spend-tier bonus-entry codes; and
 * - existing time-based bonus-entry campaigns.
 *
 * Safety rules:
 * - qualifying merchandise uses original line prices before discounts;
 * - reward gifts, Route protection, and nested bundle children never qualify;
 * - a product gift remains in the cart only when Shopify confirms that the
 *   configured discount makes that exact tagged line free;
 * - existing customer-entered discount codes are preserved and take priority;
 * - reward writes are serialized and stop when a newer customer change arrives.
 */
(() => {
  "use strict";

  if (window.LGNDCartDrawerRewards) return;

  const REWARDS_CONFIG_SELECTOR = "[data-lgnd-cart-rewards-config]";
  const BONUS_CONFIG_SELECTOR = "[data-lgnd-bonus-cart-gift-config]";
  const REWARDS_ROOT_SELECTOR = "[data-lgnd-cart-rewards]";
  const CART_MUTATION_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/;
  const CONTROLLER_SOURCE = "cart-drawer-rewards";
  const STORED_CODES_KEY = "lgnd:cart-drawer-rewards:auto-codes";
  const LEGACY_STORED_CODES_KEY = "lgnd:auto-bonus-cart-gift-code";
  const FAILURE_COOLDOWN_MS = 60 * 1000;
  const REJECTION_VERIFICATION_DELAY_MS = 250;
  const MAX_DISCOUNT_CODES = 5;

  // Standalone Fast Pass gift: independent of spend tiers and their toggle.
  // Shopify's automatic discount must use this exact title.
  const FAST_PASS_GIFT = Object.freeze({
    enabled: false,
    rewardId: "lgnd-fast-pass-apex-gift",
    productId: "8177184571542",
    productHandle: "fast-pass",
    variantId: "43779667132566",
    giftVariantId: "46397127098518",
    title: "Apex Key Loop",
    discountTitle: "FAST PASS GIFT",
    giftsPerPass: 1
  });

  // Route Code Edited 9/11/2026
  const ROUTE_HANDLE = "routeins";
  // End Route Code

  const routeRoot =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

  const cartBaseRoute = routeRoot.replace(/\/?$/, "/") + "cart";
  const originalFetch = window.fetch.bind(window);

  const state = {
    syncing: false,
    syncQueued: false,
    syncTimer: 0,
    boundaryTimer: 0,
    failureTimer: 0,
    latestCart: null,
    giftFailures: new Map(),
    codeFailures: new Map(),
    skippedCodes: new Set(),
    report: null
  };


  // Opt-in Elements diagnostics. Enable with ?rewards_debug=1; disable with
  // ?rewards_debug=0. The trace persists in this tab across cart page reloads.
  // No extra requests or cart mutations are made by this diagnostic layer.
  const REWARDS_DEBUG_VERSION = "2026-10-01-quantity-debug-v2";
  const REWARDS_DEBUG_KEY = "lgnd:rewards:elements-debug";
  const rewardsDebug = {
    enabled: false, stage: "loaded", pass: 0, sequence: 0,
    events: [], lastProblem: null, current: null
  };

  (function initializeRewardsDebug() {
    try {
      const requested = new URL(window.location.href).searchParams.get("rewards_debug");
      if (requested === "0") {
        window.sessionStorage.removeItem(REWARDS_DEBUG_KEY);
        window.sessionStorage.removeItem(REWARDS_DEBUG_KEY + ":trace");
      } else if (requested === "1") {
        window.sessionStorage.setItem(REWARDS_DEBUG_KEY, "1");
      }
      rewardsDebug.enabled = requested === "1" ||
        (requested !== "0" && window.sessionStorage.getItem(REWARDS_DEBUG_KEY) === "1");
      if (rewardsDebug.enabled) {
        const previous = JSON.parse(window.sessionStorage.getItem(REWARDS_DEBUG_KEY + ":trace") || "null");
        if (previous && previous.version === REWARDS_DEBUG_VERSION) {
          rewardsDebug.events = Array.isArray(previous.events) ? previous.events.slice(-40) : [];
          rewardsDebug.lastProblem = previous.lastProblem || null;
          rewardsDebug.sequence = Number(previous.sequence || 0);
          rewardsDebug.pass = Number(previous.pass || 0);
        }
      }
    } catch (error) {
      // Debug still works for this page if browser storage is unavailable.
      rewardsDebug.enabled = /[?&]rewards_debug=1(?:&|$)/.test(window.location.search || "");
    }
  })();

  function debugDiscount(application) {
    if (!application) return null;
    return {
      title: String(application.title || application.code || ""),
      type: application.type || null,
      value: application.value ?? null,
      valueType: application.value_type || null,
      targetType: application.target_type || null,
      allocationMethod: application.allocation_method || null,
      totalAllocatedAmount: application.total_allocated_amount ?? null
    };
  }

  function debugLine(item) {
    const props = getProperties(item);
    return {
      key: item.key || null,
      productId: item.product_id || null,
      variantId: item.variant_id || item.id || null,
      title: item.product_title || item.title || null,
      handle: item.handle || null,
      quantity: item.quantity,
      originalPrice: item.original_price ?? null,
      originalLinePrice: item.original_line_price ?? null,
      finalPrice: item.final_price ?? null,
      finalLinePrice: item.final_line_price ?? null,
      totalDiscount: item.total_discount ?? null,
      countsTowardThreshold: isTopLevelMerchandise(item),
      isRewardGift: isAnyRewardGift(item),
      isRoute: isRouteProtection(item),
      isBundleChild: Boolean(item.parent_relationship || item.parent_id),
      rewardId: props._lgnd_reward_id || null,
      rewardTitle: props._lgnd_reward_title || null,
      expectedDiscountProperty: props._lgnd_reward_discount || null,
      discountTitles: discountTitlesForLine(item),
      discounts: (Array.isArray(item.discounts) ? item.discounts : []).map(d => ({
        title: d.title || "", amount: d.amount ?? null
      })),
      allocations: (Array.isArray(item.line_level_discount_allocations)
        ? item.line_level_discount_allocations
        : Array.isArray(item.discount_allocations) ? item.discount_allocations : []).map(a => ({
          amount: a.amount ?? null, application: debugDiscount(a.discount_application)
        }))
    };
  }

  function debugCart(cart) {
    if (!cart) return null;
    const items = Array.isArray(cart.items) ? cart.items : [];
    return {
      currency: cart.currency || null,
      itemCount: cart.item_count ?? null,
      totalPrice: cart.total_price ?? null,
      originalTotalPrice: cart.original_total_price ?? null,
      qualifyingSubtotal: getQualifyingSubtotal(cart),
      fastPassQuantity: getFastPassQuantity(cart),
      discountCodes: (Array.isArray(cart.discount_codes) ? cart.discount_codes : []).map(d => ({
        code: d.code || d.title || "", applicable: d.applicable ?? null
      })),
      appliedCodes: getAppliedCodes(cart),
      cartDiscounts: (Array.isArray(cart.cart_level_discount_applications)
        ? cart.cart_level_discount_applications : []).map(debugDiscount),
      discountApplications: (Array.isArray(cart.discount_applications)
        ? cart.discount_applications : []).map(debugDiscount),
      items: items.slice(0, 80).map(debugLine),
      truncatedItems: Math.max(0, items.length - 80)
    };
  }

  function debugTier(tier, cart) {
    return {
      id: tier.id, type: tier.type, title: tier.title,
      thresholdCents: tier.thresholdCents ?? null,
      thresholdBaseCents: tier.thresholdBaseCents ?? null,
      qualifiesBySpend: Number.isFinite(tier.thresholdCents)
        ? getQualifyingSubtotal(cart) >= tier.thresholdCents : null,
      giftProductId: tier.gift && tier.gift.productId || null,
      giftVariantId: tier.gift && tier.gift.variantId || null,
      giftAvailable: tier.gift && tier.gift.available !== undefined ? tier.gift.available : null,
      expectedQuantity: getGiftQuantity(tier),
      expectedDiscountTitle: tier.gift && tier.gift.expectedDiscountTitle || null,
      configurationIssue: tier.id === FAST_PASS_GIFT.rewardId ? "" : giftConfigurationIssue(tier)
    };
  }

  function debugConfiguration(configuration, cart) {
    return {
      present: configuration.isPresent, enabled: configuration.enabled,
      currencyRate: getCurrencyRate(), errors: configuration.errors,
      tiers: configuration.tiers.map(t => debugTier(t, cart)),
      // Include raw tier summaries to reveal ignored Apex variants, zero
      // thresholds, invalid variants, or competing section configurations.
      sources: Array.from(document.querySelectorAll(REWARDS_CONFIG_SELECTOR)).map((el, index) => {
        try {
          const raw = JSON.parse(el.textContent || "{}");
          return {
            index, selected: index === document.querySelectorAll(REWARDS_CONFIG_SELECTOR).length - 1,
            enabled: raw.enabled,
            tiers: (Array.isArray(raw.tiers) ? raw.tiers : []).map(t => ({
              id: t.id, type: t.type, title: t.title,
              thresholdBaseCents: t.thresholdBaseCents,
              productId: t.gift && t.gift.productId,
              variantId: t.gift && t.gift.variantId,
              available: t.gift && t.gift.available,
              expectedDiscountTitle: t.gift && t.gift.expectedDiscountTitle,
              ignoredBecauseReservedForFastPass: t.type === "free_gift" &&
                normalizeId(t.gift && t.gift.variantId) === FAST_PASS_GIFT.giftVariantId
            }))
          };
        } catch (error) { return {index, error: String(error.message)}; }
      })
    };
  }

  function debugFailureList(map) {
    return Array.from(map, ([id, failure]) => ({
      id, attempts: failure.attempts, message: failure.message,
      retryAt: new Date(failure.until).toISOString(),
      coolingDown: failure.until > Date.now()
    }));
  }

  function debugSnapshot() {
    return {
      version: REWARDS_DEBUG_VERSION, enabled: rewardsDebug.enabled,
      capturedAt: new Date().toISOString(), pagePath: window.location.pathname,
      moneyUnits: "All numeric price/threshold amounts are Shopify minor units (USD cents).",
      stage: rewardsDebug.stage, pass: rewardsDebug.pass, sequence: rewardsDebug.sequence,
      controller: {
        syncing: state.syncing, queued: state.syncQueued,
        epoch: syncControl.epoch, runEpoch: syncControl.runEpoch,
        revision: syncControl.revision, pendingMutations: syncControl.pendingMutations,
        writing: syncControl.writing
      },
      current: rewardsDebug.current,
      giftFailures: debugFailureList(state.giftFailures),
      codeFailures: debugFailureList(state.codeFailures),
      lastProblem: rewardsDebug.lastProblem,
      report: state.report, events: rewardsDebug.events
    };
  }

  function publishRewardsDebug() {
    if (!rewardsDebug.enabled) return;
    try {
      const snapshot = debugSnapshot();
      const text = JSON.stringify(snapshot, null, 2);
      let node = document.getElementById("lgnd-cart-rewards-debug");
      if (!node) {
        const parent = document.body || document.documentElement;
        if (!parent) return;
        node = document.createElement("script");
        node.id = "lgnd-cart-rewards-debug";
        node.type = "application/json";
        parent.appendChild(node);
      }
      node.setAttribute("data-version", REWARDS_DEBUG_VERSION);
      node.setAttribute("data-stage", rewardsDebug.stage);
      node.textContent = text;
      try {
        window.sessionStorage.setItem(REWARDS_DEBUG_KEY + ":trace", JSON.stringify({
          version: REWARDS_DEBUG_VERSION, pass: rewardsDebug.pass,
          sequence: rewardsDebug.sequence, events: rewardsDebug.events.slice(-40),
          lastProblem: rewardsDebug.lastProblem
        }));
      } catch (error) {}
    } catch (error) {
      // Diagnostics must never interrupt cart processing.
    }
  }

  function debugRecord(event, details = {}, problem = false) {
    if (!rewardsDebug.enabled) return;
    try {
      const entry = {
        sequence: ++rewardsDebug.sequence, at: new Date().toISOString(),
        pagePath: window.location.pathname, pass: rewardsDebug.pass,
        stage: rewardsDebug.stage, event, details
      };
      rewardsDebug.events.push(entry);
      rewardsDebug.events = rewardsDebug.events.slice(-50);
      if (problem) rewardsDebug.lastProblem = entry;
      publishRewardsDebug();
    } catch (error) {}
  }

  function debugStage(stage, cart) {
    if (!rewardsDebug.enabled) return;
    rewardsDebug.stage = stage;
    if (cart) rewardsDebug.current = debugCart(cart);
    debugRecord("stage", {stage});
  }

  // LGND CART DRAWER REWARDS — NORMALIZATION HELPERS START
  function normalizeCode(value) {
    return String(value || "").trim().toLowerCase();
  }

  function normalizeId(value) {
    const normalized = String(value || "").trim();

    return normalized && normalized !== "0" && normalized !== "null"
      ? normalized
      : "";
  }

  function normalizeCampaignType(value) {
    const normalized = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ");

    if (!normalized || normalized === "store wide") return "store_wide";
    if (normalized === "product specific") return "product_specific";

    return "";
  }

  function uniqueValues(values, normalizer) {
    const results = [];
    const keys = new Set();

    values.forEach((value) => {
      const normalized = normalizer(value);
      if (!normalized || keys.has(normalized)) return;

      keys.add(normalized);
      results.push(String(value).trim());
    });

    return results;
  }

  function parseShopifyDate(value) {
    if (typeof value === "number" && Number.isFinite(value)) {
      return value > 100000000000 ? value : value * 1000;
    }

    let dateValue = String(value || "").trim();
    if (!dateValue) return null;

    const hasTimeZone = /(?:z|[+-]\d{2}:?\d{2})$/i.test(dateValue);
    const isIsoDateTime = /^\d{4}-\d{2}-\d{2}t\d{2}:\d{2}/i.test(dateValue);

    if (isIsoDateTime && !hasTimeZone) dateValue += "Z";

    const timestamp = Date.parse(dateValue);
    return Number.isFinite(timestamp) ? timestamp : null;
  }

  function getCurrencyRate() {
    const currency =
      window.Shopify && window.Shopify.currency
        ? window.Shopify.currency
        : {};

    const rate = Number(currency.rate);
    return Number.isFinite(rate) && rate > 0 ? rate : 1;
  }

  function convertThreshold(baseCents) {
    return Math.max(
      0,
      Math.round(Number(baseCents || 0) * getCurrencyRate())
    );
  }

  function valuesMatch(leftValues, rightValues, normalizer) {
    const left = uniqueValues(leftValues, normalizer)
      .map(normalizer)
      .sort();

    const right = uniqueValues(rightValues, normalizer)
      .map(normalizer)
      .sort();

    return left.join("|") === right.join("|");
  }

  function wait(milliseconds) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, milliseconds);
    });
  }
  // LGND CART DRAWER REWARDS — NORMALIZATION HELPERS END

  // LGND CART DRAWER REWARDS — CONFIGURATION READER START
  function normalizeCampaign(rawCampaign) {
    const raw =
      rawCampaign && typeof rawCampaign === "object"
        ? rawCampaign
        : {};

    const startsAt = parseShopifyDate(raw.startsAt);
    const endsAt = parseShopifyDate(raw.endsAt);
    const campaignType = normalizeCampaignType(raw.campaignType);

    const qualifyingProductIds = uniqueValues(
      Array.isArray(raw.qualifyingProductIds)
        ? raw.qualifyingProductIds
        : [],
      normalizeId
    ).map(normalizeId);

    const excludedProductIds = uniqueValues(
      Array.isArray(raw.excludedProductIds)
        ? raw.excludedProductIds
        : [],
      normalizeId
    ).map(normalizeId);

    return {
      id: normalizeId(raw.id || raw.campaignId),
      code: String(raw.code || "").trim(),
      autoApply: raw.autoApply === true,
      startsAt,
      endsAt,
      campaignType,
      qualifyingProductIds,
      excludedProductIds,
      entries: Math.max(0, Number(raw.entries || 0)),
      title: String(raw.title || "Bonus Entries Gift").trim(),
      image: raw.image || null
    };
  }

  function campaignTargetingIssue(campaign) {
    if (!campaign || !campaign.code) return "missing discount code";
    if (!campaign.campaignType) return "invalid campaign type";

    if (
      campaign.campaignType === "product_specific" &&
      !campaign.qualifyingProductIds.length
    ) {
      return "product-specific campaign has no qualifying products";
    }

    return "";
  }

  function campaignConfigurationIssue(campaign) {
    const targetingIssue = campaignTargetingIssue(campaign);
    if (targetingIssue) return targetingIssue;

    if (campaign.startsAt === null) return "missing or invalid start date";
    if (campaign.endsAt === null) return "missing or invalid end date";

    if (campaign.endsAt < campaign.startsAt) {
      return "end date is before start date";
    }

    return "";
  }

  // Cart Reward blocks control their own activation and threshold.
  // Standalone auto-apply and scheduling fields do not control them.
  function tierBonusConfigurationIssue(campaign) {
    return campaignTargetingIssue(campaign);
  }

  function readRewardsConfiguration() {
    let rawConfiguration = null;
    const errors = [];

    document.querySelectorAll(REWARDS_CONFIG_SELECTOR).forEach((element) => {
      try {
        const parsed = JSON.parse(element.textContent || "{}");

        if (parsed && typeof parsed === "object") {
          rawConfiguration = parsed;
        }
      } catch (error) {
        errors.push(
          error && error.message
            ? error.message
            : "Invalid rewards JSON"
        );
      }
    });

    const raw = rawConfiguration || {};
    const tiers = [];
    const tierIds = new Set();

    (Array.isArray(raw.tiers) ? raw.tiers : []).forEach((rawTier, index) => {
      const tierId = String(
        (rawTier && rawTier.id) || "tier-" + index
      ).trim();

      const type = String(
        (rawTier && rawTier.type) || ""
      ).trim();

      const thresholdBaseCents = Math.max(
        0,
        Math.round(
          Number((rawTier && rawTier.thresholdBaseCents) || 0)
        )
      );

      if (
        !tierId ||
        tierIds.has(tierId) ||
        !["free_shipping", "free_gift", "bonus_entries"].includes(type) ||
        thresholdBaseCents <= 0
      ) {
        return;
      }

      tierIds.add(tierId);

      const rawGift =
        rawTier.gift && typeof rawTier.gift === "object"
          ? rawTier.gift
          : {};

      // The Fast Pass promotion replaces the old Apex spend reward.
      // Ignore a stale Apex tier if an older section still renders it.
      if (
        type === "free_gift" &&
        normalizeId(rawGift.variantId) === FAST_PASS_GIFT.giftVariantId
      ) {
        return;
      }

      const bonus = normalizeCampaign(rawTier.bonus);

      tiers.push({
        id: tierId,
        order: index,
        type,
        title: String(rawTier.title || "Reward").trim() || "Reward",
        thresholdBaseCents,
        thresholdCents: convertThreshold(thresholdBaseCents),
        memberOverride: rawTier.memberOverride === true,
        icon: rawTier.icon || null,
        gift: {
          productId: normalizeId(rawGift.productId),
          variantId: normalizeId(rawGift.variantId),
          available: rawGift.available === true,
          singleVariant: rawGift.singleVariant === true,
          productTitle: String(rawGift.productTitle || "").trim(),
          expectedDiscountTitle: String(
            rawGift.expectedDiscountTitle || ""
          ).trim()
        },
        bonus
      });
    });

    tiers.sort((left, right) => {
      return (
        left.thresholdBaseCents - right.thresholdBaseCents ||
        left.order - right.order
      );
    });

    const configuredOffset = Number(raw.firstMilestoneOffset);

    return {
      isPresent: Boolean(rawConfiguration),
      enabled: raw.enabled === true,
      member: raw.member === true,
      memberTag: String(raw.memberTag || "").trim(),
      storeCurrency: String(raw.storeCurrency || "USD").trim(),
      presentmentCurrency: String(
        raw.presentmentCurrency ||
          (
            window.Shopify &&
            window.Shopify.currency &&
            window.Shopify.currency.active
              ? window.Shopify.currency.active
              : "USD"
          )
      ).trim(),
      firstMilestoneOffset: Number.isFinite(configuredOffset)
        ? Math.max(0, Math.min(configuredOffset, 25))
        : 10,
      messages: {
        next: String(
          (raw.messages && raw.messages.next) ||
            "You're [amount] away from [reward]!"
        ),
        complete: String(
          (raw.messages && raw.messages.complete) ||
            "You've unlocked every reward!"
        ),
        memberShipping: String(
          (raw.messages && raw.messages.memberShipping) ||
            "Member Free-Shipping unlocked!"
        )
      },
      tiers,
      errors
    };
  }

  function readTimedBonusConfiguration() {
    const campaigns = [];
    const campaignKeys = new Set();
    const appliedDiscountCodes = [];
    const appliedCodeKeys = new Set();
    const errors = [];
    const elements = document.querySelectorAll(BONUS_CONFIG_SELECTOR);

    elements.forEach((element) => {
      try {
        const raw = JSON.parse(element.textContent || "{}");

        (Array.isArray(raw.campaigns) ? raw.campaigns : []).forEach(
          (rawCampaign) => {
            const campaign = normalizeCampaign(rawCampaign);

            const campaignKey = [
              normalizeCode(campaign.code),
              campaign.startsAt,
              campaign.endsAt,
              campaign.campaignType,
              campaign.qualifyingProductIds.slice().sort().join(","),
              campaign.excludedProductIds.slice().sort().join(",")
            ].join("|");

            if (campaignKeys.has(campaignKey)) return;

            campaignKeys.add(campaignKey);
            campaigns.push(campaign);
          }
        );

        (
          Array.isArray(raw.appliedDiscountCodes)
            ? raw.appliedDiscountCodes
            : []
        ).forEach((code) => {
          const key = normalizeCode(code);
          if (!key || appliedCodeKeys.has(key)) return;

          appliedCodeKeys.add(key);
          appliedDiscountCodes.push(String(code).trim());
        });
      } catch (error) {
        errors.push(
          error && error.message
            ? error.message
            : "Invalid bonus JSON"
        );
      }
    });

    return {
      isPresent: elements.length > 0,
      campaigns,
      appliedDiscountCodes,
      errors
    };
  }

  // function giftConfigurationIssue(tier) {
  //   if (!tier || tier.type !== "free_gift") return "";

  //   if (!tier.gift.productId || !tier.gift.variantId) {
  //     return "no gift product selected";
  //   }

  //   if (!tier.gift.singleVariant) {
  //     return "gift product must have one variant";
  //   }

  //   if (!tier.gift.available) {
  //     return "gift product is unavailable";
  //   }

  //   if (!tier.gift.expectedDiscountTitle) {
  //     return "expected Buy X Get Y title is blank";
  //   }

  //   return "";
  // }

  function giftConfigurationIssue(tier) {
  if (!tier || tier.type !== "free_gift") return "";

  if (!tier.gift.productId) {
    return "no gift product selected";
  }

  // Multi-variant products are now supported.
  // Liquid only supplies a variantId when the configured Variant ID
  // belongs to the selected product. Single-variant products continue
  // to resolve their default variant automatically.
  if (!tier.gift.variantId) {
    return "no valid gift variant selected";
  }

  if (!tier.gift.available) {
    return "gift variant is unavailable";
  }

  if (!tier.gift.expectedDiscountTitle) {
    return "expected Buy X Get Y title is blank";
  }

  return "";
}
  // LGND CART DRAWER REWARDS — CONFIGURATION READER END

  // LGND CART DRAWER REWARDS — CART AND ELIGIBILITY HELPERS START
  function getProperties(item) {
    return item &&
      item.properties &&
      typeof item.properties === "object"
      ? item.properties
      : {};
  }

  function propertyIsTrue(item, propertyName) {
    return (
      String(getProperties(item)[propertyName] || "")
        .trim()
        .toLowerCase() === "true"
    );
  }

  function isTierRewardGift(item) {
    return propertyIsTrue(item, "_lgnd_reward_gift");
  }

  function isLegacyRewardGift(item) {
    return propertyIsTrue(item, "_free_gift");
  }

  function isAnyRewardGift(item) {
    return isTierRewardGift(item) || isLegacyRewardGift(item);
  }

  function isRouteProtection(item) {
    const title = String(
      (item && (item.product_title || item.title)) || ""
    ).toLowerCase();

    return title.includes("shipping protection by route");
  }

  function isTopLevelMerchandise(item) {
    return Boolean(
      item &&
        Number(item.quantity || 0) > 0 &&
        !item.parent_relationship &&
        !item.parent_id &&
        !isAnyRewardGift(item) &&
        !isRouteProtection(item)
    );
  }

  function getMerchandiseItems(cart) {
    return cart && Array.isArray(cart.items)
      ? cart.items.filter(isTopLevelMerchandise)
      : [];
  }

  function getQualifyingSubtotal(cart) {
    return getMerchandiseItems(cart).reduce((subtotal, item) => {
      const originalLinePrice = Number(item.original_line_price);

      const fallbackPrice =
        Number(item.original_price || item.price || 0) *
        Number(item.quantity || 0);

      return (
        subtotal +
        (
          Number.isFinite(originalLinePrice)
            ? originalLinePrice
            : fallbackPrice
        )
      );
    }, 0);
  }

  // LGND GIFT SUBTOTAL — START (2026-10-27)
  // Mirrors how Shopify counts a Buy X Get Y "minimum purchase amount":
  // - Fast Pass counts (its own free gift ended 2026-11-02);
  // - subscription lines (LGND+ membership) never count;
  // - a line that already carries another product discount does not count.
  // Used only for free_gift spend tiers so the drawer never promises a gift
  // that Shopify will not make free. Other tiers keep getQualifyingSubtotal.
  function isFastPassLine(item) {
    return (
      normalizeId(item.product_id) === FAST_PASS_GIFT.productId ||
      normalizeId(item.variant_id) === FAST_PASS_GIFT.variantId ||
      String(item.handle || "").trim() === FAST_PASS_GIFT.productHandle
    );
  }

  function lineHasOtherProductDiscount(item) {
    const allocations = Array.isArray(item.line_level_discount_allocations)
      ? item.line_level_discount_allocations
      : Array.isArray(item.discount_allocations)
        ? item.discount_allocations
        : [];

    return allocations.some((allocation) => {
      return Number((allocation && allocation.amount) || 0) > 0;
    });
  }

  // Products left out of the gift's Shopify "customer buys" collection
  // (All Products - MINUS Sticker Pack). Keep this list in sync with it.
  // 8305533911190 = The Decal Collection - 10 Pack (Selleasy upsell).
  const GIFT_EXCLUDED_PRODUCT_IDS = new Set(["8305533911190"]);

  function isGiftExcludedLine(item) {
    return (
      GIFT_EXCLUDED_PRODUCT_IDS.has(normalizeId(item.product_id)) ||
      Boolean(item.selling_plan_allocation) ||
      lineHasOtherProductDiscount(item)
    );
  }

  // Short cart note naming the items that don't count toward the gift.
  function getGiftExclusionNote(cart) {
    const names = [];

    getMerchandiseItems(cart).forEach((item) => {
      if (!isGiftExcludedLine(item)) return;

      const name = String(item.product_title || item.title || "").trim();
      if (name && !names.includes(name)) names.push(name);
    });

    if (!names.length) return "";
    if (names.length === 1) {
      return names[0] + " doesn't count toward the free gift.";
    }
    if (names.length === 2) {
      return names[0] + " and " + names[1] + " don't count toward the free gift.";
    }
    return "Some items in your cart (memberships and already-discounted items) don't count toward the free gift.";
  }

  function getGiftQualifyingSubtotal(cart) {
    return getMerchandiseItems(cart).reduce((subtotal, item) => {
      if (isGiftExcludedLine(item)) return subtotal;

      const originalLinePrice = Number(item.original_line_price);
      const fallbackPrice =
        Number(item.original_price || item.price || 0) *
        Number(item.quantity || 0);

      return (
        subtotal +
        (Number.isFinite(originalLinePrice) ? originalLinePrice : fallbackPrice)
      );
    }, 0);
  }
  // LGND GIFT SUBTOTAL — END

  function campaignIsActive(campaign, now = Date.now()) {
    return Boolean(
      campaign &&
        campaign.autoApply &&
        !campaignConfigurationIssue(campaign) &&
        campaign.startsAt <= now &&
        now <= campaign.endsAt
    );
  }

  function campaignQualifies(campaign, merchandiseItems) {
    if (campaign.campaignType === "product_specific") {
      const qualifyingIds = new Set(campaign.qualifyingProductIds);

      return merchandiseItems.some((item) => {
        return qualifyingIds.has(normalizeId(item.product_id));
      });
    }

    if (campaign.campaignType === "store_wide") {
      const excludedIds = new Set(campaign.excludedProductIds);

      return merchandiseItems.some((item) => {
        return !excludedIds.has(normalizeId(item.product_id));
      });
    }

    return false;
  }

  function tierSpendIsReached(
    tier,
    configuration,
    cart,
    qualifyingSubtotal
  ) {
    if (tier.type === "free_shipping") {
      const memberUnlock =
        configuration.member === true &&
        tier.memberOverride === true;

      return (
        memberUnlock ||
        Math.max(
          0,
          Number(cart && cart.total_price ? cart.total_price : 0)
        ) >= tier.thresholdCents
      );
    }

    if (tier.type === "free_gift") {
      return getGiftQualifyingSubtotal(cart) >= tier.thresholdCents;
    }

    return qualifyingSubtotal >= tier.thresholdCents;
  }

  function getVisibleTiers(configuration, cart) {
    if (!configuration.enabled) return [];

    const merchandiseItems = getMerchandiseItems(cart);
    const designMode = Boolean(
      window.Shopify && window.Shopify.designMode
    );

    return configuration.tiers.filter((tier) => {
      if (tier.type === "free_gift") {
        return !giftConfigurationIssue(tier) || designMode;
      }

      if (tier.type === "bonus_entries") {
        const valid =
          !tierBonusConfigurationIssue(tier.bonus) &&
          campaignQualifies(tier.bonus, merchandiseItems);

        return valid || designMode;
      }

      return true;
    });
  }

  function getCartSignature(cart) {
    const merchandiseSignature = getMerchandiseItems(cart)
      .map((item) => {
        return [
          item.key || item.variant_id,
          item.product_id,
          item.variant_id,
          item.quantity,
          item.original_line_price
        ].join(":");
      })
      .sort()
      .join("|");

    const codeSignature = getAppliedCodes(cart)
      .map(normalizeCode)
      .sort()
      .join("|");

    return merchandiseSignature + "::" + codeSignature;
  }
  function getGiftFailureSignature(tier, cart) {
    // Shopify changes line keys and code applicability when a paid gift
    // temporarily pushes the cart over another discount's spend threshold.
    // Those changes must not bypass the cooldown for the same merchandise.
    const merchandise = getMerchandiseItems(cart)
      .map((item) => JSON.stringify([
        normalizeId(item.product_id),
        normalizeId(item.variant_id),
        Number(item.quantity || 0),
        Number(item.original_line_price),
        normalizeId(item.selling_plan_allocation &&
          item.selling_plan_allocation.selling_plan &&
          item.selling_plan_allocation.selling_plan.id)
      ]))
      .sort();

    // Retain inapplicable codes so applicability alone cannot reset backoff.
    // Adding or removing a code still permits a fresh gift attempt.
    const codes = Array.from(new Set(
      (Array.isArray(cart && cart.discount_codes)
        ? cart.discount_codes.map((entry) => entry.code)
        : getAppliedCodes(cart))
        .map(normalizeCode)
        .filter(Boolean)
    )).sort();

    return JSON.stringify([
      tier.id,
      normalizeId(tier.gift.variantId),
      tier.gift.expectedDiscountTitle,
      getGiftQuantity(tier),
      tier.thresholdCents,
      merchandise,
      codes
    ]);
  }
  // LGND CART DRAWER REWARDS — CART AND ELIGIBILITY HELPERS END

  // LGND CART DRAWER REWARDS — CART API START
  async function requestCartJson(path, options = {}) {
    // PERFORMANCE: reuse full cart responses and bundle the drawer HTML.
    // Never continue a reward plan after a newer customer cart mutation.
    assertCurrentPass();

    const isWrite =
      String(options.method || "GET").toUpperCase() !== "GET";

    const sectionIds = isWrite ? getRewardSectionIds() : [];

    if (isWrite) {
      syncControl.revision += 1;
      syncControl.snapshot = null;
      syncControl.sections = null;
      syncControl.displayDirty = true;
      syncControl.writing = true;

      if (sectionIds.length) {
        options = {
          ...options,
          body: JSON.stringify({
            ...JSON.parse(options.body || "{}"),
            sections: sectionIds,
            sections_url: window.location.pathname
          })
        };
      }
    }

    if (rewardsDebug.enabled) {
      let request = {};
      try { request = JSON.parse(options.body || "{}"); } catch (error) {}
      debugRecord("cart_request", {
        path, method: options.method || "GET",
        items: Array.isArray(request.items) ? request.items.map(i => ({variantId: i.id, quantity: i.quantity})) : undefined,
        updates: request.updates, discount: request.discount
      });
    }
    try {
      const response = await originalFetch(cartBaseRoute + path, {
        credentials: "same-origin",
        cache: "no-store",
        ...options,
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
          ...(options.headers || {})
        }
      });

      const payload = await response.json().catch(() => null);
      if (rewardsDebug.enabled) debugRecord("cart_response", {
        path, status: response.status, ok: response.ok,
        responseStale: state.syncing && (syncControl.runEpoch !== syncControl.epoch || syncControl.pendingMutations > 0),
        error: !response.ok ? String(payload && (payload.description || payload.message) || "Unknown error").slice(0, 600) : null,
        cart: payload && Array.isArray(payload.items) ? debugCart(payload) : null
      }, !response.ok);
      assertCurrentPass();

      if (!response.ok || !payload) {
        throw new Error(
          (payload && (payload.description || payload.message)) ||
            "Shopify rejected a cart update."
        );
      }

      rememberCart(payload, syncControl.revision);

      if (isWrite && payload.sections) {
        syncControl.sections = {
          values: payload.sections,
          ids: sectionIds,
          revision: syncControl.revision
        };
      }

      return payload;
    } catch (error) {
      debugRecord("cart_request_failed", {
        path, message: error === STALE_REWARDS_PASS ? "stale rewards pass" : String(error && error.message || error)
      }, error !== STALE_REWARDS_PASS);
      throw error;
    } finally {
      if (isWrite) syncControl.writing = false;
    }
  }

  async function getCart() {
    const cart = await requestCartJson(".js", {
      method: "GET"
    });

    if (!isCompleteCart(cart)) {
      throw new Error("Shopify returned an incomplete cart.");
    }

    return cart;
  }

  async function updateCartLines(updates) {
    if (!updates || !Object.keys(updates).length) return null;

    const cart = await requestCartJson("/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ updates })
    });

    return isCompleteCart(cart) ? cart : getCart();
  }

  async function addRewardGift(tier) {
    return requestCartJson("/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(tier.gift.variantId),
            quantity: getGiftQuantity(tier),
            properties: {
              _lgnd_reward_gift: "true",
              _lgnd_reward_id: tier.id,
              _lgnd_reward_title: tier.title,
              _lgnd_reward_discount: tier.gift.expectedDiscountTitle,
              _free_gift: "true"
            }
          }
        ]
      })
    });
  }

  async function updateDiscountCodes(codes) {
    const cart = await requestCartJson("/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        discount: codes.join(",")
      })
    });

    return isCompleteCart(cart) ? cart : getCart();
  }
  // LGND CART DRAWER REWARDS — CART API END

  // LGND CART DRAWER REWARDS — FAILURE BACKOFF START
  function failureIsCoolingDown(failureMap, key, signature) {
    const failure = failureMap.get(key);

    return Boolean(
      failure &&
        failure.signature === signature &&
        Number(failure.until) > Date.now()
    );
  }

  function storeFailure(failureMap, key, signature, message) {
    const existing = failureMap.get(key);

    const attempts =
      existing && existing.signature === signature
        ? Number(existing.attempts || 1) + 1
        : 1;

    failureMap.set(key, {
      signature,
      attempts,
      message: String(message || "Reward could not be applied."),
      until: Date.now() + FAILURE_COOLDOWN_MS
    });

    debugRecord("failure_stored", {
      kind: failureMap === state.giftFailures ? "gift" : "code",
      id: key, attempts, message: String(message || "Reward could not be applied.")
    });
    scheduleFailureRetry();
  }

  function clearFailure(failureMap, key) {
    failureMap.delete(key);
    scheduleFailureRetry();
  }

  function scheduleFailureRetry() {
    window.clearTimeout(state.failureTimer);
    state.failureTimer = 0;

    const now = Date.now();

    const retryTimes = [
      ...state.giftFailures.values(),
      ...state.codeFailures.values()
    ]
      .filter((failure) => {
        return (
          failure &&
          Number(failure.attempts || 1) === 1 &&
          Number(failure.until) > now
        );
      })
      .map((failure) => Number(failure.until));

    if (!retryTimes.length) return;

    const retryAt = Math.min(...retryTimes);

    state.failureTimer = window.setTimeout(() => {
      state.failureTimer = 0;
      requestFreshSync();
    }, Math.max(50, retryAt - now + 50));
  }
  // LGND CART DRAWER REWARDS — FAILURE BACKOFF END


    function getGiftQuantity(tier) {
    const quantity = Math.floor(
      Number(tier && tier.gift && tier.gift.quantity)
    );

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  // LGND CART DRAWER REWARDS — FREE PRODUCT RECONCILIATION START
  function rewardIdFromLine(item) {
    return String(
      getProperties(item)._lgnd_reward_id || ""
    ).trim();
  }

  function getGiftAssignments(cart, giftTiers) {
    const giftLines = Array.isArray(cart.items)
      ? cart.items.filter(isAnyRewardGift)
      : [];

    const usedKeys = new Set();
    const assignments = new Map();

    giftTiers.forEach((tier) => {
      const exactLine = giftLines.find((item) => {
        const properties = getProperties(item);

        return (
          !usedKeys.has(item.key) &&
          rewardIdFromLine(item) === tier.id &&
          normalizeId(item.variant_id) === tier.gift.variantId &&
          String(properties._lgnd_reward_title || "").trim() ===
            tier.title &&
          normalizeCode(properties._lgnd_reward_discount) ===
            normalizeCode(tier.gift.expectedDiscountTitle)
        );
      });

      if (!exactLine) return;

      usedKeys.add(exactLine.key);
      assignments.set(tier.id, exactLine);
    });

    giftTiers.forEach((tier) => {
      if (assignments.has(tier.id)) return;

      const legacyLine = giftLines.find((item) => {
        return (
          !usedKeys.has(item.key) &&
          !rewardIdFromLine(item) &&
          isLegacyRewardGift(item) &&
          normalizeId(item.variant_id) === tier.gift.variantId
        );
      });

      if (!legacyLine) return;

      usedKeys.add(legacyLine.key);
      assignments.set(tier.id, legacyLine);
    });

    return {
      giftLines,
      usedKeys,
      assignments
    };
  }

  function discountTitlesForLine(item) {
    const titles = [];

    (
      Array.isArray(item && item.discounts)
        ? item.discounts
        : []
    ).forEach((discount) => {
      const title = String(
        (discount && discount.title) || ""
      ).trim();

      if (title) titles.push(title);
    });

    const allocations = Array.isArray(
      item && item.line_level_discount_allocations
    )
      ? item.line_level_discount_allocations
      : Array.isArray(item && item.discount_allocations)
        ? item.discount_allocations
        : [];

    allocations.forEach((allocation) => {
      const application =
        allocation && allocation.discount_application
          ? allocation.discount_application
          : {};

      const title = String(
        application.title || application.code || ""
      ).trim();

      if (title) titles.push(title);
    });

    return uniqueValues(titles, normalizeCode);
  }

  function rewardGiftIsVerified(item, tier) {
        if (
      !item ||
      Number(item.quantity || 0) !== getGiftQuantity(tier)
    ) {
      return false;
    }
    if (Number(item.final_line_price) !== 0) return false;

    const expectedTitle = normalizeCode(
      tier.gift.expectedDiscountTitle
    );

    if (!expectedTitle) return false;

    return discountTitlesForLine(item).some((title) => {
      return normalizeCode(title) === expectedTitle;
    });
  }

  function getFastPassQuantity(cart) {
    return getMerchandiseItems(cart).reduce((quantity, item) => {
      const matches =
        normalizeId(item.product_id) === FAST_PASS_GIFT.productId ||
        normalizeId(item.variant_id) === FAST_PASS_GIFT.variantId ||
        String(item.handle || "").trim() === FAST_PASS_GIFT.productHandle;

      return quantity + (matches ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  // function getFastPassGiftTier(cart) {
  //   if (!FAST_PASS_GIFT.enabled || getFastPassQuantity(cart) < 1) {
  //     clearFailure(state.giftFailures, FAST_PASS_GIFT.rewardId);
  //     return null;
  //   }

  //   // This private reward uses the existing serialized gift controller.
  //   // It is deliberately not added to configuration.tiers or the progress bar.
  //   // No product lookup is needed: add.js validates the exact variant and stock.
  //   // Existing reconciliation caps this reward at ONE, regardless of Pass qty.
  //   return {
  //     id: FAST_PASS_GIFT.rewardId,
  //     type: "free_gift",
  //     title: FAST_PASS_GIFT.title,
  //     gift: {
  //       variantId: FAST_PASS_GIFT.giftVariantId,
  //       expectedDiscountTitle: FAST_PASS_GIFT.discountTitle
  //     }
  //   };
  // }

    function getFastPassGiftTier(cart) {
    const passQuantity = getFastPassQuantity(cart);

    if (!FAST_PASS_GIFT.enabled || passQuantity < 1) {
      clearFailure(state.giftFailures, FAST_PASS_GIFT.rewardId);
      return null;
    }

    // Gift quantity follows Fast Pass quantity (1:1 by default).
    // Shopify's FAST PASS GIFT discount must have NO per-order use limit.
    return {
      id: FAST_PASS_GIFT.rewardId,
      type: "free_gift",
      title: FAST_PASS_GIFT.title,
      gift: {
        variantId: FAST_PASS_GIFT.giftVariantId,
        expectedDiscountTitle: FAST_PASS_GIFT.discountTitle,
        quantity: passQuantity * FAST_PASS_GIFT.giftsPerPass
      }
    };
  }

  function getEligibleGiftTiers(configuration, cart) {
    const qualifyingSubtotal = getGiftQualifyingSubtotal(cart);
    const configuredTiers = configuration.enabled ? configuration.tiers : [];

    const eligibleTiers = configuredTiers.filter((tier) => {
      if (tier.type !== "free_gift") return false;

      // This specific Apex variant is reserved for the Fast Pass promotion.
      if (normalizeId(tier.gift.variantId) === FAST_PASS_GIFT.giftVariantId) {
        return false;
      }

      const configurationIssue = giftConfigurationIssue(tier);

      if (configurationIssue) {
        console.warn(
          "[LGND Cart Drawer Rewards] " +
            tier.title +
            " is inactive: " +
            configurationIssue +
            "."
        );
        return false;
      }

      const qualifies = qualifyingSubtotal >= tier.thresholdCents;
      if (!qualifies) clearFailure(state.giftFailures, tier.id);
      return qualifies;
    });

    // Always evaluate Fast Pass, even without section JSON or enabled tiers.
    const fastPassTier = getFastPassGiftTier(cart);
    if (fastPassTier) eligibleTiers.push(fastPassTier);

    return eligibleTiers;
  }

  async function reconcileGiftLines(cart, configuration) {
    let workingCart = cart;
    let changed = false;

    // Eligibility handles disabled/missing spend rewards separately from
    // the standalone Fast Pass gift. Unassigned automatic gifts are removed.
    const eligibleTiers = getEligibleGiftTiers(
      configuration,
      workingCart
    );

    let assignmentState = getGiftAssignments(
      workingCart,
      eligibleTiers
    );

    if (rewardsDebug.enabled) debugRecord("gift_plan", {
      eligible: eligibleTiers.map(t => debugTier(t, workingCart)),
      assignments: Array.from(assignmentState.assignments, ([tierId, item]) => ({tierId, line: debugLine(item)}))
    });

    const updates = {};

    assignmentState.giftLines.forEach((item) => {
      if (!assignmentState.usedKeys.has(item.key)) {
        if (rewardsDebug.enabled) debugRecord("unassigned_gift_removed", {line: debugLine(item)});
        updates[item.key] = 0;
      }
    });

        eligibleTiers.forEach((tier) => {
      const item = assignmentState.assignments.get(tier.id);
      const expectedQuantity = getGiftQuantity(tier);

      if (item && Number(item.quantity || 0) !== expectedQuantity) {
        updates[item.key] = expectedQuantity;
      }
    });

    if (Object.keys(updates).length) {
      // PERFORMANCE: no follow-up GET is needed after a successful update.
      workingCart = await updateCartLines(updates);
      changed = true;

      assignmentState = getGiftAssignments(
        workingCart,
        eligibleTiers
      );
    }

    let giftWasAdded = false;

    for (const tier of eligibleTiers) {
      if (assignmentState.assignments.has(tier.id)) continue;

      const failureSignature = getGiftFailureSignature(tier, workingCart);

      if (
        failureIsCoolingDown(
          state.giftFailures,
          tier.id,
          failureSignature
        )
      ) {
        if (rewardsDebug.enabled) debugRecord("gift_add_skipped_cooldown", {
          tier: debugTier(tier, workingCart), failure: state.giftFailures.get(tier.id).message
        });
        continue;
      }

      try {
        if (rewardsDebug.enabled) debugRecord("gift_add_attempt", {tier: debugTier(tier, workingCart)});
        await addRewardGift(tier);
        giftWasAdded = true;
        changed = true;
      } catch (error) {
        if (error === STALE_REWARDS_PASS) throw error;

        storeFailure(
          state.giftFailures,
          tier.id,
          failureSignature,
          error && error.message
            ? error.message
            : "Gift could not be added."
        );

        console.warn(
          "[LGND Cart Drawer Rewards] " +
            tier.title +
            " could not be added:",
          error
        );

        // An add error can leave a partial change; confirm before proceeding.
        workingCart = await getCart();

        assignmentState = getGiftAssignments(
          workingCart,
          eligibleTiers
        );
      }
    }

    if (giftWasAdded) {
      // add.js returns added lines, not a full cart. Keep this confirmation
      // read, but remove the artificial 100 ms wait.
      workingCart = await getCart();
    }

    return {
      cart: workingCart,
      changed,
      eligibleTiers
    };
  }

  async function verifyGiftLines(cart, eligibleTiers) {
    let workingCart = cart;
    let changed = false;

    const verifiedTierIds = new Set();
    const assignmentState = getGiftAssignments(
      workingCart,
      eligibleTiers
    );

    const updates = {};

    eligibleTiers.forEach((tier) => {
      const item = assignmentState.assignments.get(tier.id);

      if (rewardGiftIsVerified(item, tier)) {
        if (rewardsDebug.enabled) debugRecord("gift_verified", {tier: debugTier(tier, workingCart), line: debugLine(item)});
        verifiedTierIds.add(tier.id);
        clearFailure(state.giftFailures, tier.id);
        return;
      }

      if (!item) {
        if (rewardsDebug.enabled) debugRecord("gift_not_present_at_verification", {tier: debugTier(tier, workingCart)});
        return;
      }

      if (rewardsDebug.enabled) {
        const reasons = [];
        if (Number(item.quantity || 0) !== getGiftQuantity(tier)) reasons.push("quantity_mismatch");
        if (Number(item.final_line_price) !== 0) reasons.push("gift_line_not_fully_free");
        if (!discountTitlesForLine(item).some(title => normalizeCode(title) === normalizeCode(tier.gift.expectedDiscountTitle))) {
          reasons.push("expected_discount_title_missing");
        }
        debugRecord("gift_rejected_before_removal", {
          reasons, tier: debugTier(tier, workingCart), line: debugLine(item),
          cartBeforeRemoval: debugCart(workingCart)
        }, true);
      }
      updates[item.key] = 0;

      const failureSignature = getGiftFailureSignature(tier, workingCart);

      storeFailure(
        state.giftFailures,
        tier.id,
        failureSignature,
        "Shopify did not confirm the expected free-gift discount."
      );

      console.warn(
        "[LGND Cart Drawer Rewards] " +
          tier.title +
          " was removed because Shopify did not make that tagged line free with " +
          tier.gift.expectedDiscountTitle +
          "."
      );
    });

    if (Object.keys(updates).length) {
      // PERFORMANCE: use the confirmed removal response directly.
      workingCart = await updateCartLines(updates);
      changed = true;
    }

    return {
      cart: workingCart,
      changed,
      verifiedTierIds
    };
  }
  // LGND CART DRAWER REWARDS — FREE PRODUCT RECONCILIATION END

  // LGND CART DRAWER REWARDS — DISCOUNT CODE RECONCILIATION START
  function addCode(codeMap, code) {
    const displayCode = String(code || "").trim();
    const normalized = normalizeCode(displayCode);

    if (!normalized || codeMap.has(normalized)) return;

    codeMap.set(normalized, displayCode);
  }

  function addDiscountApplication(codeMap, application) {
    if (!application) return;

    const type = String(application.type || "").toLowerCase();
    if (type !== "discount_code") return;

    addCode(codeMap, application.code || application.title);
  }

  function getAppliedCodes(cart, fallbackCodes = []) {
    const codeMap = new Map();

    const hasExplicitCodes = Boolean(
      cart && Array.isArray(cart.discount_codes)
    );

    if (hasExplicitCodes) {
      cart.discount_codes.forEach((discount) => {
        if (!discount || discount.applicable === false) return;

        addCode(codeMap, discount.code || discount.title);
      });
    }

    [
      cart && cart.discount_applications,
      cart && cart.cart_level_discount_applications
    ]
      .filter(Array.isArray)
      .forEach((applications) => {
        applications.forEach((application) => {
          addDiscountApplication(codeMap, application);
        });
      });

    (
      cart && Array.isArray(cart.items)
        ? cart.items
        : []
    ).forEach((item) => {
      const allocations = Array.isArray(
        item.line_level_discount_allocations
      )
        ? item.line_level_discount_allocations
        : Array.isArray(item.discount_allocations)
          ? item.discount_allocations
          : [];

      allocations.forEach((allocation) => {
        addDiscountApplication(
          codeMap,
          allocation.discount_application
        );
      });
    });

    if (!hasExplicitCodes && !codeMap.size) {
      fallbackCodes.forEach((code) => {
        addCode(codeMap, code);
      });
    }

    return Array.from(codeMap.values());
  }

  function codeListHas(codes, code) {
    const target = normalizeCode(code);

    return Boolean(
      target &&
        codes.some((candidate) => {
          return normalizeCode(candidate) === target;
        })
    );
  }

  function readStorage(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(storage, key, value) {
    try {
      if (value) {
        storage.setItem(key, value);
      } else {
        storage.removeItem(key);
      }
    } catch (error) {
      // Storage may be unavailable in private browsing; cart syncing continues.
    }
  }

  function getStoredAutomaticCodes(cart) {
    const storedValue =
      readStorage(window.localStorage, STORED_CODES_KEY) ||
      readStorage(window.localStorage, LEGACY_STORED_CODES_KEY);

    if (!storedValue) return [];

    try {
      const parsed = JSON.parse(storedValue);

      if (
        parsed &&
        parsed.cartToken &&
        cart &&
        cart.token &&
        parsed.cartToken !== cart.token
      ) {
        return [];
      }

      if (parsed && Array.isArray(parsed.codes)) {
        return uniqueValues(parsed.codes, normalizeCode);
      }

      if (parsed && parsed.code) {
        return uniqueValues([parsed.code], normalizeCode);
      }
    } catch (error) {
      return uniqueValues([storedValue], normalizeCode);
    }

    return [];
  }

  function setStoredAutomaticCodes(codes, cart) {
    const storedCodes = uniqueValues(codes, normalizeCode);

    writeStorage(
      window.localStorage,
      LEGACY_STORED_CODES_KEY,
      ""
    );

    if (!storedCodes.length) {
      writeStorage(
        window.localStorage,
        STORED_CODES_KEY,
        ""
      );

      return;
    }

    writeStorage(
      window.localStorage,
      STORED_CODES_KEY,
      JSON.stringify({
        cartToken: cart && cart.token ? cart.token : null,
        codes: storedCodes
      })
    );
  }

  function getCampaignPlan(
    rewardsConfiguration,
    timedConfiguration,
    cart
  ) {
    const merchandiseItems = getMerchandiseItems(cart);
    const qualifyingSubtotal = getQualifyingSubtotal(cart);

    const selectedTierCodes = new Set();
    const managedCodes = [];
    const candidates = [];

    if (rewardsConfiguration.enabled) {
      rewardsConfiguration.tiers.forEach((tier) => {
        if (tier.type !== "bonus_entries" || !tier.bonus.code) {
          return;
        }

        selectedTierCodes.add(normalizeCode(tier.bonus.code));
        managedCodes.push(tier.bonus.code);

        if (
          !tierBonusConfigurationIssue(tier.bonus) &&
          qualifyingSubtotal >= tier.thresholdCents &&
          campaignQualifies(tier.bonus, merchandiseItems)
        ) {
          candidates.push({
            ...tier.bonus,
            source: "tier",
            tierId: tier.id,
            thresholdCents: tier.thresholdCents
          });
        } else {
          clearFailure(
            state.codeFailures,
            normalizeCode(tier.bonus.code)
          );
        }
      });
    }

    timedConfiguration.campaigns.forEach((campaign) => {
      if (campaign.autoApply) managedCodes.push(campaign.code);

      if (selectedTierCodes.has(normalizeCode(campaign.code))) {
        return;
      }

      if (
        campaignIsActive(campaign) &&
        campaignQualifies(campaign, merchandiseItems)
      ) {
        candidates.push({
          ...campaign,
          source: "timed",
          tierId: "",
          thresholdCents: 0
        });
      } else {
        clearFailure(
          state.codeFailures,
          normalizeCode(campaign.code)
        );
      }
    });

    const candidatesByCode = new Map();

    candidates
      .sort((left, right) => {
        if (left.source !== right.source) {
          return left.source === "tier" ? -1 : 1;
        }

        return (
          Number(left.thresholdCents || 0) -
          Number(right.thresholdCents || 0)
        );
      })
      .forEach((campaign) => {
        const key = normalizeCode(campaign.code);

        if (key && !candidatesByCode.has(key)) {
          candidatesByCode.set(key, campaign);
        }
      });

    return {
      candidates: Array.from(candidatesByCode.values()),
      managedCodes: uniqueValues(
        [
          ...managedCodes,
          ...getStoredAutomaticCodes(cart)
        ],
        normalizeCode
      )
    };
  }

  async function reconcileDiscountCodes(
    cart,
    rewardsConfiguration,
    timedConfiguration
  ) {
    const currentCodes = getAppliedCodes(
      cart,
      timedConfiguration.appliedDiscountCodes
    );

    const campaignPlan = getCampaignPlan(
      rewardsConfiguration,
      timedConfiguration,
      cart
    );

    const managedKeys = new Set(
      campaignPlan.managedCodes.map(normalizeCode)
    );

    const qualifiedKeys = new Set(
      campaignPlan.candidates.map((campaign) => {
        return normalizeCode(campaign.code);
      })
    );

    const manualCodes = currentCodes.filter((code) => {
      return !managedKeys.has(normalizeCode(code));
    });

    const existingQualifiedAutomaticCodes = currentCodes.filter((code) => {
      const key = normalizeCode(code);

      return managedKeys.has(key) && qualifiedKeys.has(key);
    });

    const orderedCandidates = [
      ...campaignPlan.candidates.filter((campaign) => {
        return codeListHas(
          existingQualifiedAutomaticCodes,
          campaign.code
        );
      }),
      ...campaignPlan.candidates.filter((campaign) => {
        return !codeListHas(
          existingQualifiedAutomaticCodes,
          campaign.code
        );
      })
    ];

    const availableSlots = Math.max(
      0,
      MAX_DISCOUNT_CODES - manualCodes.length
    );

    const automaticCodes = [];
    const attemptedCampaigns = [];

    state.skippedCodes = new Set();

    orderedCandidates.forEach((campaign) => {
      const key = normalizeCode(campaign.code);

      if (!key || codeListHas(automaticCodes, campaign.code)) {
        return;
      }

      if (automaticCodes.length >= availableSlots) {
        state.skippedCodes.add(key);
        return;
      }

      if (codeListHas(currentCodes, campaign.code)) {
        automaticCodes.push(campaign.code);
        return;
      }

      const failureSignature =
        key +
        "::" +
        getCartSignature(cart) +
        "::" +
        manualCodes.map(normalizeCode).sort().join("|");

      if (
        failureIsCoolingDown(
          state.codeFailures,
          key,
          failureSignature
        )
      ) {
        return;
      }

      automaticCodes.push(campaign.code);
      attemptedCampaigns.push({
        campaign,
        failureSignature
      });
    });

    const targetCodes = uniqueValues(
      [...manualCodes, ...automaticCodes],
      normalizeCode
    );

    let resultingCart = cart;
    let resultingCodes = currentCodes;

    if (!valuesMatch(currentCodes, targetCodes, normalizeCode)) {
      resultingCart = await updateDiscountCodes(targetCodes);
      resultingCodes = getAppliedCodes(resultingCart);

      const attemptedCodeMissing = attemptedCampaigns.some(
        ({ campaign }) => {
          return !codeListHas(resultingCodes, campaign.code);
        }
      );

      if (attemptedCodeMissing) {
        await wait(REJECTION_VERIFICATION_DELAY_MS);

        resultingCart = await getCart();
        resultingCodes = getAppliedCodes(resultingCart);
      }

      const missingManualCodes = manualCodes.filter((code) => {
        return !codeListHas(resultingCodes, code);
      });

      if (missingManualCodes.length) {
        const rollbackCodes = uniqueValues(
          [
            ...manualCodes,
            ...existingQualifiedAutomaticCodes
          ],
          normalizeCode
        );

        resultingCart = await updateDiscountCodes(rollbackCodes);

        await wait(REJECTION_VERIFICATION_DELAY_MS);

        resultingCart = await getCart();
        resultingCodes = getAppliedCodes(resultingCart);

        attemptedCampaigns.forEach(
          ({ campaign, failureSignature }) => {
            storeFailure(
              state.codeFailures,
              normalizeCode(campaign.code),
              failureSignature,
              "The reward code conflicted with an existing customer discount."
            );
          }
        );

        console.warn(
          "[LGND Cart Drawer Rewards] Automatic reward codes were rolled back so an existing customer discount would not be removed."
        );
      } else {
        const rejectedAttemptExists = attemptedCampaigns.some(
          ({ campaign }) => {
            return !codeListHas(resultingCodes, campaign.code);
          }
        );

        if (rejectedAttemptExists) {
          // Remove non-applicable raw codes from Shopify's discount_codes array
          // so failed $0 markers do not linger or consume a code slot.
          const cleanCodes = targetCodes.filter((code) => {
            return codeListHas(resultingCodes, code);
          });

          if (!valuesMatch(targetCodes, cleanCodes, normalizeCode)) {
            resultingCart = await updateDiscountCodes(cleanCodes);
            resultingCart = await getCart();
            resultingCodes = getAppliedCodes(resultingCart);
          }
        }
      }
    }

    attemptedCampaigns.forEach(
      ({ campaign, failureSignature }) => {
        const key = normalizeCode(campaign.code);

        if (codeListHas(resultingCodes, campaign.code)) {
          clearFailure(state.codeFailures, key);
          return;
        }

        storeFailure(
          state.codeFailures,
          key,
          failureSignature,
          "Shopify did not report this reward code as applicable."
        );

        console.warn(
          "[LGND Cart Drawer Rewards] " +
            campaign.code +
            " was attempted but Shopify did not report it as applicable."
        );
      }
    );

    const appliedAutomaticCodes = campaignPlan.candidates
      .map((campaign) => campaign.code)
      .filter((code) => codeListHas(resultingCodes, code));

    setStoredAutomaticCodes(
      appliedAutomaticCodes,
      resultingCart
    );

    return {
      cart: resultingCart,
      changed: !valuesMatch(
        currentCodes,
        resultingCodes,
        normalizeCode
      ),
      currentCodes,
      resultingCodes,
      appliedAutomaticCodes,
      targetCodes
    };
  }
  // LGND CART DRAWER REWARDS — DISCOUNT CODE RECONCILIATION END

  // LGND CART DRAWER REWARDS — PROGRESS AND REWARD ROW UI START
  function formatMoney(cents, currencyCode) {
    const numericCents = Math.max(
      0,
      Math.round(Number(cents || 0))
    );

    const hasFraction = numericCents % 100 !== 0;

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || "en-US",
        {
          style: "currency",
          currency: currencyCode || "USD",
          currencyDisplay: "narrowSymbol",
          minimumFractionDigits: hasFraction ? 2 : 0,
          maximumFractionDigits: hasFraction ? 2 : 0
        }
      ).format(numericCents / 100);
    } catch (error) {
      return (
        (numericCents / 100).toFixed(hasFraction ? 2 : 0) +
        " " +
        (currencyCode || "USD")
      );
    }
  }

  function replaceMessageTokens(template, amount, reward) {
    return String(template || "")
      .split("[amount]")
      .join(amount)
      .split("[reward]")
      .join(reward);
  }

  // LGND CART DRAWER REWARDS — BALANCED MILESTONES START
  function getBalancedTierPosition(
    index,
    tierCount,
    firstMilestoneOffset
  ) {
    if (index < 0 || tierCount <= 0) return 0;
    if (tierCount === 1) return 100;

    const offset = Math.max(
      0,
      Math.min(Number(firstMilestoneOffset || 0), 25)
    );

    return offset + (index / (tierCount - 1)) * (100 - offset);
  }

  function getBalancedTierProgress(
    visibleTiers,
    qualifyingSubtotal,
    firstMilestoneOffset
  ) {
    if (!visibleTiers.length) return 0;

    let previousThreshold = 0;
    let previousPosition = 0;

    for (let index = 0; index < visibleTiers.length; index += 1) {
      const threshold = Math.max(
        previousThreshold,
        Number(visibleTiers[index].thresholdCents || 0)
      );

      const targetPosition = getBalancedTierPosition(
        index,
        visibleTiers.length,
        firstMilestoneOffset
      );

      if (qualifyingSubtotal < threshold) {
        const thresholdRange = threshold - previousThreshold;

        const progressWithinSegment =
          thresholdRange > 0
            ? Math.max(
                0,
                Math.min(
                  (
                    qualifyingSubtotal - previousThreshold
                  ) / thresholdRange,
                  1
                )
              )
            : 0;

        return Math.min(
          100,
          previousPosition +
            progressWithinSegment *
              (targetPosition - previousPosition)
        );
      }

      previousThreshold = threshold;
      previousPosition = targetPosition;
    }

    return 100;
  }
  // LGND CART DRAWER REWARDS — BALANCED MILESTONES END

  function getTierStates(configuration, cart, visibleTiers) {
    const qualifyingSubtotal = getQualifyingSubtotal(cart);
    const appliedCodes = getAppliedCodes(cart);

    const giftTiers = visibleTiers.filter((tier) => {
      return tier.type === "free_gift";
    });

    const giftAssignments = getGiftAssignments(
      cart,
      giftTiers
    ).assignments;

    return visibleTiers.map((tier) => {
      const spendReached = tierSpendIsReached(
        tier,
        configuration,
        cart,
        qualifyingSubtotal
      );

      let unlocked = spendReached;
      let invalid = false;
      let pending = false;

      if (tier.type === "free_gift") {
        const item = giftAssignments.get(tier.id);

        unlocked =
          spendReached &&
          rewardGiftIsVerified(item, tier);

        invalid =
          spendReached &&
          (
            Boolean(giftConfigurationIssue(tier)) ||
            state.giftFailures.has(tier.id)
          );

        pending =
          spendReached &&
          !unlocked &&
          !invalid &&
          state.syncing;
      }

      if (tier.type === "bonus_entries") {
        const codeKey = normalizeCode(tier.bonus.code);

        unlocked =
          spendReached &&
          !tierBonusConfigurationIssue(tier.bonus) &&
          campaignQualifies(
            tier.bonus,
            getMerchandiseItems(cart)
          ) &&
          codeListHas(appliedCodes, tier.bonus.code);

        invalid =
          spendReached &&
          (
            Boolean(tierBonusConfigurationIssue(tier.bonus)) ||
            state.codeFailures.has(codeKey) ||
            state.skippedCodes.has(codeKey)
          );

        pending =
          spendReached &&
          !unlocked &&
          !invalid &&
          state.syncing;
      }

      if (tier.type === "free_shipping") {
        invalid = false;
        pending = false;
      }

      return {
        tier,
        spendReached,
        unlocked,
        invalid,
        pending
      };
    });
  }

  function getRewardNotice(tierStates) {
    const invalidState = tierStates.find((tierState) => {
      return tierState.invalid;
    });

    if (!invalidState) return "";

    if (invalidState.tier.type === "free_gift") {
      return (
        invalidState.tier.title +
        " encountered an issue adding to cart. Please try again."
      );
    }

    if (invalidState.tier.type === "bonus_entries") {
      if (
        state.skippedCodes.has(
          normalizeCode(invalidState.tier.bonus.code)
        )
      ) {
        return (
          invalidState.tier.title +
          " could not be applied because this cart already has the maximum number of discount codes."
        );
      }

      return (
        invalidState.tier.title +
        " could not be applied. Your existing cart discounts were left unchanged."
      );
    }

    return "";
  }

  function updateRewardRows(configuration, tierStates) {
    const stateById = new Map(
      tierStates.map((tierState) => {
        return [tierState.tier.id, tierState];
      })
    );

    document.querySelectorAll("[data-lgnd-reward-row]").forEach((row) => {
      const tierState = stateById.get(
        String(row.dataset.rewardId || "")
      );

      const shouldShow = Boolean(
        configuration.enabled &&
          tierState &&
          tierState.unlocked &&
          tierState.tier.type !== "free_gift"
      );

      row.hidden = !shouldShow;

      if (!shouldShow) return;

      const status = row.querySelector(
        "[data-lgnd-reward-row-status]"
      );

      if (!status) return;

      if (
        tierState.tier.type === "free_shipping" &&
        configuration.member &&
        tierState.tier.memberOverride
      ) {
        status.textContent = configuration.messages.memberShipping;
      } else if (tierState.tier.type === "bonus_entries") {
        status.textContent =
          tierState.tier.bonus.code + " applied";
      } else {
        status.textContent = "Unlocked";
      }
    });
  }

  function updateRewardUI(cart) {
    const configuration = readRewardsConfiguration();
    const roots = document.querySelectorAll(REWARDS_ROOT_SELECTOR);

    if (!cart || !configuration.enabled || !configuration.tiers.length) {
      roots.forEach((root) => {
        root.hidden = true;
      });

      document.querySelectorAll("[data-lgnd-reward-row]").forEach((row) => {
        row.hidden = true;
      });

      return;
    }

    const visibleTiers = getVisibleTiers(configuration, cart);

    const tierStates = getTierStates(
      configuration,
      cart,
      visibleTiers
    );

    const stateById = new Map(
      tierStates.map((tierState) => {
        return [tierState.tier.id, tierState];
      })
    );

    const qualifyingSubtotal = getQualifyingSubtotal(cart);

    const allUnlocked =
      tierStates.length > 0 &&
      tierStates.every((tierState) => tierState.unlocked);

    // LGND GIFT SUBTOTAL — keep the fill from passing an unreached gift
    // marker; inside the gift segment the fill follows the gift count.
    let progressSubtotal = qualifyingSubtotal;
    const giftSubtotal = getGiftQualifyingSubtotal(cart);
    const unreachedGiftTier = visibleTiers.find((tier) => {
      return tier.type === "free_gift" && giftSubtotal < tier.thresholdCents;
    });

    if (unreachedGiftTier) {
      const floorBeforeGift = visibleTiers.reduce((floor, tier) => {
        const threshold = Number(tier.thresholdCents || 0);
        return threshold < unreachedGiftTier.thresholdCents &&
          qualifyingSubtotal >= threshold
          ? Math.max(floor, threshold)
          : floor;
      }, 0);

      progressSubtotal = Math.min(
        qualifyingSubtotal,
        Math.max(giftSubtotal, floorBeforeGift)
      );
    }

    let progress = getBalancedTierProgress(
      visibleTiers,
      progressSubtotal,
      configuration.firstMilestoneOffset
    );

    if (allUnlocked) progress = 100;

    roots.forEach((root) => {
      if (!visibleTiers.length) {
        root.hidden = true;
        return;
      }

      root.hidden = false;

      root.style.setProperty(
        "--lgnd-rewards-progress",
        progress + "%"
      );

      const track = root.querySelector(
        "[data-lgnd-rewards-track]"
      );

      if (track) {
        track.setAttribute(
          "aria-valuenow",
          String(Math.round(progress))
        );
      }

      root.querySelectorAll("[data-lgnd-reward-milestone]").forEach(
        (milestone) => {
          const tierId = String(
            milestone.dataset.rewardId || ""
          );

          const tierState = stateById.get(tierId);

          milestone.hidden = !tierState;

          milestone.classList.toggle(
            "is-unlocked",
            Boolean(tierState && tierState.unlocked)
          );

          milestone.classList.toggle(
            "is-invalid",
            Boolean(tierState && tierState.invalid)
          );

          milestone.classList.toggle(
            "is-pending",
            Boolean(tierState && tierState.pending)
          );

          if (!tierState) return;

          const tierIndex = visibleTiers.findIndex((tier) => {
            return tier.id === tierId;
          });

          const position = getBalancedTierPosition(
            tierIndex,
            visibleTiers.length,
            configuration.firstMilestoneOffset
          );

          milestone.style.setProperty(
            "--lgnd-reward-position",
            position + "%"
          );

          milestone.dataset.rewardState = tierState.invalid
            ? "invalid"
            : tierState.unlocked
              ? "unlocked"
              : tierState.pending
                ? "pending"
                : "locked";

          const title = milestone.querySelector(
            ".lgnd-cart-rewards__milestone-title"
          );

          const thresholdLabel = milestone.querySelector(
            "[data-lgnd-reward-threshold-label]"
          );

          if (title) {
            title.textContent = tierState.tier.title;
          }

          if (thresholdLabel) {
            thresholdLabel.textContent = formatMoney(
              tierState.tier.thresholdCents,
              configuration.presentmentCurrency
            );
          }
        }
      );

      const message = root.querySelector(
        "[data-lgnd-rewards-message]"
      );

      const notice = root.querySelector(
        "[data-lgnd-rewards-notice]"
      );

      const nextState = tierStates.find((tierState) => {
        return !tierState.unlocked;
      });

      let messageText = configuration.messages.complete;

      if (nextState) {
        const basis =
          nextState.tier.type === "free_shipping"
            ? Math.max(0, Number(cart.total_price || 0))
            : nextState.tier.type === "free_gift"
              ? getGiftQualifyingSubtotal(cart)
              : qualifyingSubtotal;

        const remaining = Math.max(
          nextState.tier.thresholdCents - basis,
          0
        );

        if (nextState.invalid) {
          messageText =
            nextState.tier.title + " is temporarily unavailable.";
        } else if (nextState.pending || remaining === 0) {
          messageText =
            nextState.tier.type === "free_gift"
              ? "Adding " + nextState.tier.title + "…"
              : "Applying " + nextState.tier.title + "…";
        } else {
          messageText = replaceMessageTokens(
             configuration.messages.next,
             formatMoney(remaining, configuration.presentmentCurrency),
             nextState.tier.type === "free_gift" ? "a " + nextState.tier.title  : nextState.tier.title
          );
        }
      } else {
        const memberShippingState = tierStates.find((tierState) => {
          return (
            tierState.tier.type === "free_shipping" &&
            tierState.tier.memberOverride &&
            configuration.member
          );
        });

        if (memberShippingState && tierStates.length === 1) {
          messageText = configuration.messages.memberShipping;
        }
      }

      if (message) {
        message.textContent = messageText;

        if (track) {
          track.setAttribute("aria-valuetext", messageText);
        }
      }

      let noticeText = getRewardNotice(tierStates);

      if (!noticeText) {
        const lockedGiftState = tierStates.find((tierState) => {
          return tierState.tier.type === "free_gift" && !tierState.unlocked;
        });

        if (lockedGiftState) noticeText = getGiftExclusionNote(cart);
      }

      if (notice) {
        notice.hidden = !noticeText;
        notice.textContent = noticeText;
      }
    });

    updateRewardRows(configuration, tierStates);
  }
  // LGND CART DRAWER REWARDS — PROGRESS AND REWARD ROW UI END

  // LGND CART DRAWER REWARDS — SYNCHRONIZED CONTROLLER START
  // PERFORMANCE: confirmed snapshots, shared reads and stale-pass protection.
  const STALE_REWARDS_PASS = Symbol("stale rewards pass");

  const syncControl = {
    epoch: 0,
    runEpoch: 0,
    revision: 0,
    pendingMutations: 0,
    writing: false,
    snapshot: null,
    reads: new Set(),
    knownCarts: new Map(),
    sections: null,
    displayDirty: false,
    timerDue: 0
  };

  function isCompleteCart(cart) {
    return Boolean(
      cart &&
        Array.isArray(cart.items) &&
        typeof cart.item_count === "number" &&
        typeof cart.total_price === "number"
    );
  }

  function cartSnapshotKey(cart) {
    // Section HTML is presentation only and may be attached by Prestige later.
    return JSON.stringify({
      ...cart,
      sections: undefined
    });
  }

  function rememberCart(cart, revision) {
    if (!isCompleteCart(cart)) return;

    const key = cartSnapshotKey(cart);

    syncControl.knownCarts.delete(key);
    syncControl.knownCarts.set(key, revision);

    if (syncControl.knownCarts.size > 12) {
      syncControl.knownCarts.delete(
        syncControl.knownCarts.keys().next().value
      );
    }
  }

  function assertCurrentPass() {
    if (
      state.syncing &&
      (
        syncControl.runEpoch !== syncControl.epoch ||
        syncControl.pendingMutations > 0
      )
    ) {
      state.syncQueued = true;
      throw STALE_REWARDS_PASS;
    }
  }

  function invalidateCart() {
    syncControl.epoch += 1;
    syncControl.revision += 1;
    syncControl.snapshot = null;
    syncControl.sections = null;

    state.latestCart = null;
    state.syncQueued = true;

    setCheckoutPending(true);
  }

  function acceptCart(cart) {
    if (!isCompleteCart(cart)) return;

    rememberCart(cart, syncControl.revision);

    syncControl.snapshot = {
      cart,
      revision: syncControl.revision
    };

    state.latestCart = cart;
    updateRewardUI(cart);
  }

  async function getStartingCart() {
    assertCurrentPass();

    if (
      syncControl.snapshot &&
      syncControl.snapshot.revision === syncControl.revision
    ) {
      return syncControl.snapshot.cart;
    }

    // Prestige reads cart.js after add.js. Share that in-flight read if present.
    const read = Array.from(syncControl.reads).find((entry) => {
      return (
        entry.revision === syncControl.revision &&
        !entry.duringRewardWrite
      );
    });

    if (read) {
      const cart = await read.promise;
      assertCurrentPass();

      if (
        read.revision === syncControl.revision &&
        isCompleteCart(cart)
      ) {
        return cart;
      }
    }

    return getCart();
  }

  function getRewardSectionIds() {
    if (!document.querySelector("cart-drawer")) return [];

    const sections = [];

    document.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections }
      })
    );

    const ids = [
      ...new Set(
        sections.filter((id) => {
          return typeof id === "string" && id.length > 0;
        })
      )
    ];

    // Shopify supports five. Use the normal refresh if a theme needs more.
    return ids.length <= 5 ? ids : [];
  }

  function scheduleDateBoundary(
    rewardsConfiguration,
    timedConfiguration
  ) {
    window.clearTimeout(state.boundaryTimer);
    state.boundaryTimer = 0;

    const now = Date.now();

    const selectedCodes = new Set(
      rewardsConfiguration.enabled
        ? rewardsConfiguration.tiers
            .filter((tier) => tier.type === "bonus_entries")
            .map((tier) => normalizeCode(tier.bonus.code))
        : []
    );

    const boundaries = [];

    // Tier-selected campaigns are spend-driven; only standalone promos need timers.
    timedConfiguration.campaigns.forEach((campaign) => {
      if (
        !campaign ||
        !campaign.autoApply ||
        selectedCodes.has(normalizeCode(campaign.code))
      ) {
        return;
      }

      if (campaign.startsAt > now) {
        boundaries.push(campaign.startsAt);
      }

      if (campaign.endsAt >= now) {
        boundaries.push(campaign.endsAt + 1000);
      }
    });

    if (!boundaries.length) return;

    const delay = Math.min(
      Math.max(Math.min(...boundaries) - now, 250),
      2147483000
    );

    state.boundaryTimer = window.setTimeout(() => {
      invalidateCart();
      scheduleSync(0);
    }, delay);
  }

  function setCheckoutPending(pending) {
    document
      .querySelectorAll(
        'button[name="checkout"], input[name="checkout"]'
      )
      .forEach((checkoutControl) => {
        if (pending) {
          if (!checkoutControl.disabled) {
            checkoutControl.dataset.lgndRewardsLock = "true";
            checkoutControl.disabled = true;
          }

          checkoutControl.setAttribute("aria-busy", "true");
          return;
        }

        checkoutControl.removeAttribute("aria-busy");

        if (checkoutControl.dataset.lgndRewardsLock === "true") {
          checkoutControl.disabled = false;
          delete checkoutControl.dataset.lgndRewardsLock;
        }
      });
  }

  function refreshCartDisplay(cart) {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }

    const bundle = syncControl.sections;

    let validBundle = Boolean(
      bundle &&
        bundle.revision === syncControl.revision &&
        bundle.ids.length &&
        bundle.ids.every((id) => {
          return (
            typeof bundle.values[id] === "string" &&
            bundle.values[id].trim()
          );
        })
    );

    if (validBundle) {
      // A null/missing section must never be passed to Prestige's parser.
      validBundle = bundle.ids.some((id) => {
        return new DOMParser()
          .parseFromString(bundle.values[id], "text/html")
          .querySelector("cart-drawer");
      });
    }

    if (validBundle) {
      document.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            source: CONTROLLER_SOURCE,
            baseEvent: "rewards:sync",
            cart: {
              ...cart,
              sections: bundle.values
            }
          }
        })
      );
    } else {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            source: CONTROLLER_SOURCE
          }
        })
      );
    }

    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          source: CONTROLLER_SOURCE,
          cart
        }
      })
    );
  }

  async function synchronizeCartRewards() {
    const rewardsConfiguration = readRewardsConfiguration();
    const timedConfiguration = readTimedBonusConfiguration();

    scheduleDateBoundary(
      rewardsConfiguration,
      timedConfiguration
    );

    rewardsDebug.pass += 1;
    debugStage("starting");
    let cart = await getStartingCart();
    assertCurrentPass();
    if (rewardsDebug.enabled) debugRecord("configuration", {
      rewards: debugConfiguration(rewardsConfiguration, cart),
      timedConfigurationErrors: timedConfiguration.errors
    });
    debugStage("reconcile_gifts", cart);

    // Paint the real spend immediately; rewards remain pending until confirmed.
    acceptCart(cart);

    const giftReconciliation = await reconcileGiftLines(
      cart,
      rewardsConfiguration
    );

    assertCurrentPass();
    cart = giftReconciliation.cart;

    debugStage("verify_before_bonus_codes", cart);
    const firstGiftVerification = await verifyGiftLines(
      cart,
      giftReconciliation.eligibleTiers
    );

    assertCurrentPass();
    cart = firstGiftVerification.cart;
    acceptCart(cart);

    debugStage("reconcile_bonus_codes", cart);
    const discountReconciliation = await reconcileDiscountCodes(
      cart,
      rewardsConfiguration,
      timedConfiguration
    );

    assertCurrentPass();
    cart = discountReconciliation.cart;

    // Keep the second check: a bonus discount can invalidate a free-gift discount.
    debugStage("verify_after_bonus_codes", cart);
    const finalGiftVerification = await verifyGiftLines(
      cart,
      giftReconciliation.eligibleTiers
    );

    assertCurrentPass();
    cart = finalGiftVerification.cart;

    state.report = {
      checkedAt: new Date().toISOString(),
      qualifyingSubtotal: getQualifyingSubtotal(cart),
      postDiscountTotal: Number(cart.total_price || 0),
      appliedCodes: getAppliedCodes(cart),
      fastPassQuantity: getFastPassQuantity(cart),
      fastPassGiftEnabled: FAST_PASS_GIFT.enabled,
      fastPassGiftVerified: finalGiftVerification.verifiedTierIds.has(
        FAST_PASS_GIFT.rewardId
      ),
      verifiedGiftTierIds: Array.from(
        finalGiftVerification.verifiedTierIds
      ),
      rewardsConfigurationErrors: rewardsConfiguration.errors,
      timedConfigurationErrors: timedConfiguration.errors
    };

    acceptCart(cart);
    debugStage("completed", cart);

    if (syncControl.displayDirty) {
      syncControl.displayDirty = false;
      refreshCartDisplay(cart);
    }
  }

  async function runSyncQueue() {
    window.clearTimeout(state.syncTimer);
    state.syncTimer = 0;
    syncControl.timerDue = 0;

    if (state.syncing || syncControl.pendingMutations) return;

    state.syncing = true;
    setCheckoutPending(true);

    try {
      do {
        state.syncQueued = false;
        syncControl.runEpoch = syncControl.epoch;

        try {
          await synchronizeCartRewards();
        } catch (error) {
          if (error === STALE_REWARDS_PASS) {
            debugRecord("pass_interrupted_by_new_cart_change");
            state.syncQueued = true;
          } else {
            // Do not reuse a cart from a partially completed/failed pass.
            syncControl.snapshot = null;
            state.latestCart = null;

            debugRecord("sync_failed", {message: String(error && error.message || error)}, true);
            console.warn(
              "[LGND Cart Drawer Rewards] Sync failed:",
              error
            );

            if (syncControl.displayDirty) {
              syncControl.sections = null;
              syncControl.displayDirty = false;
              refreshCartDisplay(null);
            }
          }
        }
      } while (
        state.syncQueued &&
        !syncControl.pendingMutations
      );
    } finally {
      state.syncing = false;

      const pending =
        state.syncQueued ||
        syncControl.pendingMutations > 0;

      setCheckoutPending(pending);

      if (state.latestCart) {
        updateRewardUI(state.latestCart);
      }

      if (state.syncQueued && !syncControl.pendingMutations) {
        scheduleSync(0);
      }
      publishRewardsDebug();
    }
  }

  function scheduleSync(delay = 0) {
    state.syncQueued = true;
    setCheckoutPending(true);

    if (state.syncing || syncControl.pendingMutations) return;

    const due = Date.now() + delay;

    // Duplicate event notifications must not keep pushing the timer back.
    if (
      state.syncTimer &&
      syncControl.timerDue <= due
    ) {
      return;
    }

    window.clearTimeout(state.syncTimer);

    syncControl.timerDue = due;
    state.syncTimer = window.setTimeout(runSyncQueue, delay);
  }

  function getRequestUrl(request) {
    if (typeof request === "string") return request;
    if (request && request.url) return request.url;
    if (request instanceof URL) return request.href;

    return "";
  }

  // Route Code Edited 9/11/2026
  // Identifies a cart/add.js response as Route-only by handle, not title —
  // isRouteProtection() matches on display title and can drift if the
  // merchant renames the line item. Used only to skip the reward-sync
  // pass below; does not replace isRouteProtection elsewhere in this file.
  function isRouteAddResponse(cart) {
    const items = Array.isArray(cart && cart.items)
      ? cart.items
      : (cart && cart.handle ? [cart] : []);

    return items.length > 0 && items.every((item) => item.handle === ROUTE_HANDLE);
  }
  // End Route Code

  function finishObservedMutation(record, response, cart) {
    syncControl.pendingMutations -= 1;

    if (rewardsDebug.enabled) debugRecord("external_cart_mutation_finished", {
      status: response && response.status, ok: response && response.ok,
      overlapped: record.overlapped, requestRevision: record.revision,
      currentRevision: syncControl.revision, pendingMutations: syncControl.pendingMutations,
      cart: cart && Array.isArray(cart.items) ? debugCart(cart) : null
    });
    const reliable =
      record.revision === syncControl.revision &&
      !record.overlapped &&
      !syncControl.pendingMutations;

    if (!reliable) {
      // Overlapping requests can finish out of order. Resolve with a fresh GET.
      syncControl.revision += 1;
      syncControl.snapshot = null;
      state.latestCart = null;
    }

    rememberCart(
      cart,
      reliable ? syncControl.revision : -1
    );

    // Route Code Edited 9/11/2026
    // Route's line item is already excluded from qualifying merchandise
    // (isTopLevelMerchandise -> isRouteProtection), so a mutation that only
    // adds/removes it can't change gift or discount eligibility. Skip the
    // reward-sync pass and release checkout instead of running the full
    // pipeline for a no-op result.
    if (
      reliable &&
      response &&
      response.ok &&
      !syncControl.pendingMutations &&
      isRouteAddResponse(cart)
    ) {
      setCheckoutPending(false);
      return;
    }
    // End Route Code

    if (
      reliable &&
      response &&
      response.ok &&
      isCompleteCart(cart)
    ) {
      acceptCart(cart);
    }

    // Only partial add responses get a short fallback window for Prestige's GET.
    scheduleSync(
      reliable &&
      response &&
      response.ok &&
      !isCompleteCart(cart)
        ? 40
        : 0
    );
  }

  // Observe responses without delaying or consuming the caller's Response body.
  window.fetch = (...args) => {
    let url;

    try {
      url = new URL(
        getRequestUrl(args[0]),
        window.location.href
      );
    } catch (error) {
      return originalFetch(...args);
    }

    const method = String(
      (args[1] && args[1].method) ||
        (args[0] && args[0].method) ||
        "GET"
    ).toUpperCase();

    const sameOrigin =
      url.origin === window.location.origin;

    const isMutation =
      sameOrigin &&
      method !== "GET" &&
      method !== "HEAD" &&
      CART_MUTATION_PATTERN.test(url.pathname);

    const isCartRead =
      sameOrigin &&
      method === "GET" &&
      /\/cart\.js$/.test(url.pathname);

    if (!isMutation && !isCartRead) {
      return originalFetch(...args);
    }

    const overlapped =
      syncControl.pendingMutations > 0 ||
      syncControl.writing;

    if (isMutation) {
      invalidateCart();
      syncControl.pendingMutations += 1;
    }

    const record = {
      revision: syncControl.revision,
      overlapped,
      duringRewardWrite: syncControl.writing,
      promise: null
    };

    const request = originalFetch(...args);

    record.promise = request
      .then(
        async (response) => {
          let cart = null;

          try {
            cart = await response.clone().json();
          } catch (error) {}

          if (isMutation) {
            finishObservedMutation(
              record,
              response,
              cart
            );
          } else {
            rememberCart(
              cart,
              record.duringRewardWrite
                ? -1
                : record.revision
            );

            if (
              response.ok &&
              record.revision === syncControl.revision &&
              !record.duringRewardWrite &&
              !syncControl.pendingMutations &&
              !syncControl.writing &&
              isCompleteCart(cart)
            ) {
              // A background read can reveal an app/other-tab change we did not see.
              const changed =
                !syncControl.snapshot ||
                cartSnapshotKey(syncControl.snapshot.cart) !==
                  cartSnapshotKey(cart);

              acceptCart(cart);

              if (
                !state.syncing &&
                (state.syncQueued || changed)
              ) {
                scheduleSync(0);
              }
            }
          }

          return response.ok &&
            !record.duringRewardWrite &&
            isCompleteCart(cart)
            ? cart
            : null;
        },
        () => {
          if (isMutation) {
            finishObservedMutation(
              record,
              null,
              null
            );
          }

          return null;
        }
      )
      .catch((error) => {
        // Observer failures must never reject the theme/app's own request.
        console.warn(
          "[LGND Cart Drawer Rewards] Cart observer failed:",
          error
        );

        return null;
      })
      .finally(() => {
        syncControl.reads.delete(record);
      });

    if (isCartRead) {
      syncControl.reads.add(record);
    }

    return request;
  };

  function eventCameFromController(event) {
    return Boolean(
      event &&
        event.detail &&
        event.detail.source === CONTROLLER_SOURCE
    );
  }

  function onCartEvent(event) {
    if (eventCameFromController(event)) return;

    const cart = event.detail && event.detail.cart;

    if (isCompleteCart(cart)) {
      const knownRevision = syncControl.knownCarts.get(
        cartSnapshotKey(cart)
      );

      if (knownRevision !== undefined) {
        if (
          knownRevision === syncControl.revision &&
          !syncControl.pendingMutations &&
          !syncControl.writing
        ) {
          acceptCart(cart);

          if (state.syncQueued && !state.syncing) {
            scheduleSync(0);
          }
        }

        return; // Duplicate or stale event; never start another full pass for it.
      }

      // The response observer will publish the payload after parsing finishes.
      if (
        syncControl.pendingMutations ||
        syncControl.reads.size
      ) {
        return;
      }

      // Support app/XHR producers that emit a full cart without using fetch.
      const overlapped = syncControl.writing;

      invalidateCart();

      if (!overlapped) {
        acceptCart(cart);
      }

      scheduleSync(0);
      return;
    }

    // Coalesce payload-free notifications into any already scheduled work.
    if (
      state.syncQueued ||
      syncControl.pendingMutations
    ) {
      return;
    }

    invalidateCart();
    scheduleSync(0);
  }

  document.addEventListener(
    "cart:change",
    onCartEvent
  );

  document.addEventListener(
    "cart:refresh",
    onCartEvent
  );

  document.addEventListener(
    "cart:updated",
    onCartEvent
  );

  document.addEventListener("cart-drawer:refreshed", () => {
    setCheckoutPending(
      state.syncing ||
        state.syncQueued ||
        syncControl.pendingMutations > 0
    );

    if (state.latestCart) {
      updateRewardUI(state.latestCart);
    }
  });

  function requestFreshSync() {
    invalidateCart();
    scheduleSync(0);
  }

  document.addEventListener(
    "shopify:section:load",
    requestFreshSync
  );

  window.addEventListener(
    "online",
    requestFreshSync
  );

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      requestFreshSync();
    }
  });

  function initialize() {
    debugRecord("controller_loaded", {version: REWARDS_DEBUG_VERSION});
    scheduleFailureRetry();
    scheduleSync(0);
  }

  window.LGNDCartDrawerRewards = {
    refresh: requestFreshSync,
    getReport: () => state.report,
    getDebug: () => rewardsDebug.enabled ? debugSnapshot() : null,
    clearDebug: () => {
      rewardsDebug.events = [];
      rewardsDebug.lastProblem = null;
      debugRecord("trace_cleared");
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
  // LGND CART DRAWER REWARDS — SYNCHRONIZED CONTROLLER END
})();